export default {
    data: [
      {
         idOF:1,
         idArticle:1,
         idDesign:1,
         pieces:[
             {
                 number:1,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:903.490999,
                      time:3.822000e+04,
                      start:1580634000.000000,
                      end:1580672220.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.742778,
                     agitation:2,
                     end:1580683020.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:608.274296,
                     time:2.352000e+04,
                     start:1580976000.000000,
                     end:1580999520.000000
                 }
             },
             {
                 number:2,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.966954,
                      time:38340,
                      start:1580634300.000000,
                      end:1580672640.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.906149,
                     agitation:2,
                     end:1580683440.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.876613,
                     time:23760,
                     start:1580976300.000000,
                     end:1581000060.000000
                 }
             },
             {
                 number:3,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.971660,
                      time:3.828000e+04,
                      start:1580634600.000000,
                      end:1580672880.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.920997,
                     agitation:2,
                     end:1580683680.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.873801,
                     time:2.352000e+04,
                     start:1580976600.000000,
                     end:1581000120.000000
                 }
             },
             {
                 number:4,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.975176,
                      time:38160,
                      start:1580634900.000000,
                      end:1580673060.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.912921,
                     agitation:2,
                     end:1580683860.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.870213,
                     time:23580,
                     start:1580976900.000000,
                     end:1581000480.000000
                 }
             },
             {
                 number:5,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.969556,
                      time:3.810000e+04,
                      start:1580635200.000000,
                      end:1580673300.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.942127,
                     agitation:2,
                     end:1580684100.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.870432,
                     time:2.382000e+04,
                     start:1580977200.000000,
                     end:1581001020.000000
                 }
             },
             {
                 number:6,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.963692,
                      time:3.792000e+04,
                      start:1580635500.000000,
                      end:1580673420.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.908561,
                     agitation:2,
                     end:1580684220.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.857340,
                     time:2.370000e+04,
                     start:1580977500.000000,
                     end:1581001200.000000
                 }
             },
             {
                 number:7,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.958505,
                      time:3.828000e+04,
                      start:1580635800.000000,
                      end:1580674080.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.868593,
                     agitation:2,
                     end:1580684880.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.850870,
                     time:2.382000e+04,
                     start:1580977800.000000,
                     end:1581001620.000000
                 }
             },
             {
                 number:8,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.960280,
                      time:3.792000e+04,
                      start:1580636100.000000,
                      end:1580674020.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.876951,
                     agitation:2,
                     end:1580684820.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.847520,
                     time:2.352000e+04,
                     start:1580978100.000000,
                     end:1581001620.000000
                 }
             },
             {
                 number:9,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.955780,
                      time:3.846000e+04,
                      start:1580636400.000000,
                      end:1580674860.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.853366,
                     agitation:2,
                     end:1580685660.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.837751,
                     time:2.352000e+04,
                     start:1580978400.000000,
                     end:1581001920.000000
                 }
             },
             {
                 number:10,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.958616,
                      time:38160,
                      start:1580636700.000000,
                      end:1580674860.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.853366,
                     agitation:2,
                     end:1580685660.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.826600,
                     time:23760,
                     start:1580978700.000000,
                     end:1581002460.000000
                 }
             },
             {
                 number:11,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.955152,
                      time:3.792000e+04,
                      start:1580672520.000000,
                      end:1580710440.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.969329,
                     agitation:2,
                     end:1580721240.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.025196,
                     time:2.364000e+04,
                     start:1580999820.000000,
                     end:1581023460.000000
                 }
             },
             {
                 number:12,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.950097,
                      time:3.822000e+04,
                      start:1580672940.000000,
                      end:1580711160.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.967233,
                     agitation:2,
                     end:1580721960.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.045995,
                     time:2.382000e+04,
                     start:1581000360.000000,
                     end:1581024180.000000
                 }
             },
             {
                 number:13,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.957130,
                      time:3.804000e+04,
                      start:1580673180.000000,
                      end:1580711220.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.957641,
                     agitation:2,
                     end:1580722020.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.044830,
                     time:23760,
                     start:1581000420.000000,
                     end:1581024180.000000
                 }
             },
             {
                 number:14,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.947885,
                      time:3.828000e+04,
                      start:1580673360.000000,
                      end:1580711640.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.953068,
                     agitation:2,
                     end:1580722440.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.048471,
                     time:2.346000e+04,
                     start:1581000780.000000,
                     end:1581024240.000000
                 }
             },
             {
                 number:15,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.952020,
                      time:3.804000e+04,
                      start:1580673600.000000,
                      end:1580711640.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.953068,
                     agitation:2,
                     end:1580722440.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.039671,
                     time:2.346000e+04,
                     start:1581001320.000000,
                     end:1581024780.000000
                 }
             },
             {
                 number:16,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.948366,
                      time:3.810000e+04,
                      start:1580673720.000000,
                      end:1580711820.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.955069,
                     agitation:2,
                     end:1580722620.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.039925,
                     time:2.352000e+04,
                     start:1581001500.000000,
                     end:1581025020.000000
                 }
             },
             {
                 number:17,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.948321,
                      time:3.810000e+04,
                      start:1580674320.000000,
                      end:1580712420.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.978091,
                     agitation:2,
                     end:1580723220.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.052342,
                     time:23400,
                     start:1581001920.000000,
                     end:1581025320.000000
                 }
             },
             {
                 number:18,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.950179,
                      time:38340,
                      start:1580674380.000000,
                      end:1580712720.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.992518,
                     agitation:2,
                     end:1580723520.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.042875,
                     time:2.382000e+04,
                     start:1581001920.000000,
                     end:1581025740.000000
                 }
             },
             {
                 number:19,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.949745,
                      time:3.840000e+04,
                      start:1580675160.000000,
                      end:1580713560.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:45.038646,
                     agitation:2,
                     end:1580724360.000000
                 },
                 tempered:{
                     state:0,
                     stateTemp:1,
                     stateTime:0,
                     tempAverage:610.120382,
                     time:1.938000e+04,
                     start:1581002220.000000,
                     end:1581021600.000000
                 }
             },
             {
                 number:20,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.947326,
                      time:3.810000e+04,
                      start:1580675160.000000,
                      end:1580713260.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:45.007885,
                     agitation:2,
                     end:1580724060.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.044815,
                     time:2.364000e+04,
                     start:1581002760.000000,
                     end:1581026400.000000
                 }
             },
             {
                 number:21,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.938224,
                      time:3.792000e+04,
                      start:1580710740.000000,
                      end:1580748660.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.818131,
                     agitation:2,
                     end:1580759460.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.924607,
                     time:2.352000e+04,
                     start:1581021900.000000,
                     end:1581045420.000000
                 }
             },
             {
                 number:22,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.936021,
                      time:3.786000e+04,
                      start:1580711460.000000,
                      end:1580749320.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.875391,
                     agitation:2,
                     end:1580760120.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.925534,
                     time:23400,
                     start:1581023760.000000,
                     end:1581047160.000000
                 }
             },
             {
                 number:23,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.932550,
                      time:38520,
                      start:1580711520.000000,
                      end:1580750040.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.892346,
                     agitation:2,
                     end:1580760840.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.939366,
                     time:2.370000e+04,
                     start:1581024480.000000,
                     end:1581048180.000000
                 }
             },
             {
                 number:24,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.942192,
                      time:37980,
                      start:1580711940.000000,
                      end:1580749920.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.907812,
                     agitation:2,
                     end:1580760720.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.940489,
                     time:23580,
                     start:1581024480.000000,
                     end:1581048060.000000
                 }
             },
             {
                 number:25,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.938821,
                      time:3.810000e+04,
                      start:1580711940.000000,
                      end:1580750040.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.892346,
                     agitation:2,
                     end:1580760840.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.936270,
                     time:23580,
                     start:1581024540.000000,
                     end:1581048120.000000
                 }
             },
             {
                 number:26,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.940292,
                      time:3.822000e+04,
                      start:1580712120.000000,
                      end:1580750340.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.887491,
                     agitation:2,
                     end:1580761140.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.920345,
                     time:2.370000e+04,
                     start:1581025080.000000,
                     end:1581048780.000000
                 }
             },
             {
                 number:27,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.929985,
                      time:3.804000e+04,
                      start:1580712720.000000,
                      end:1580750760.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.895185,
                     agitation:2,
                     end:1580761560.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.924817,
                     time:2.346000e+04,
                     start:1581025320.000000,
                     end:1581048780.000000
                 }
             },
             {
                 number:28,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.934857,
                      time:3.840000e+04,
                      start:1580713020.000000,
                      end:1580751420.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.874078,
                     agitation:2,
                     end:1580762220.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.935015,
                     time:2.364000e+04,
                     start:1581025620.000000,
                     end:1581049260.000000
                 }
             },
             {
                 number:29,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.939622,
                      time:37980,
                      start:1580713560.000000,
                      end:1580751540.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.882745,
                     agitation:2,
                     end:1580762340.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.929144,
                     time:2.382000e+04,
                     start:1581026040.000000,
                     end:1581049860.000000
                 }
             },
             {
                 number:30,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.946239,
                      time:3.792000e+04,
                      start:1580713860.000000,
                      end:1580751780.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.870718,
                     agitation:2,
                     end:1580762580.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.914816,
                     time:2.388000e+04,
                     start:1581026700.000000,
                     end:1581050580.000000
                 }
             },
             {
                 number:31,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.983598,
                      time:3.810000e+04,
                      start:1580748960.000000,
                      end:1580787060.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:44.908655,
                     agitation:1,
                     end:1580797860.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.891392,
                     time:2.352000e+04,
                     start:1581045720.000000,
                     end:1581069240.000000
                 }
             },
             {
                 number:32,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.991585,
                      time:3.792000e+04,
                      start:1580749620.000000,
                      end:1580787540.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:44.931824,
                     agitation:1,
                     end:1580798340.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.919522,
                     time:2.382000e+04,
                     start:1581047460.000000,
                     end:1581071280.000000
                 }
             },
             {
                 number:33,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.998840,
                      time:37800,
                      start:1580750220.000000,
                      end:1580788020.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:44.966306,
                     agitation:1,
                     end:1580798820.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.920536,
                     time:2.364000e+04,
                     start:1581048360.000000,
                     end:1581072000.000000
                 }
             },
             {
                 number:34,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.990953,
                      time:38160,
                      start:1580750340.000000,
                      end:1580788500.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:44.997147,
                     agitation:1,
                     end:1580799300.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.920893,
                     time:23580,
                     start:1581048420.000000,
                     end:1581072000.000000
                 }
             },
             {
                 number:35,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.997305,
                      time:37800,
                      start:1580750340.000000,
                      end:1580788140.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:44.974040,
                     agitation:1,
                     end:1580798940.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.922665,
                     time:2.352000e+04,
                     start:1581048480.000000,
                     end:1581072000.000000
                 }
             },
             {
                 number:36,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:905.004644,
                      time:38160,
                      start:1580750640.000000,
                      end:1580788800.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:45.016974,
                     agitation:1,
                     end:1580799600.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.940936,
                     time:2.346000e+04,
                     start:1581049080.000000,
                     end:1581072540.000000
                 }
             },
             {
                 number:37,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.997371,
                      time:38160,
                      start:1580751060.000000,
                      end:1580789220.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:45.006754,
                     agitation:1,
                     end:1580800020.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.940936,
                     time:2.346000e+04,
                     start:1581049080.000000,
                     end:1581072540.000000
                 }
             },
             {
                 number:38,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.997313,
                      time:38160,
                      start:1580751720.000000,
                      end:1580789880.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:44.984582,
                     agitation:1,
                     end:1580800680.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.935059,
                     time:2.352000e+04,
                     start:1581049560.000000,
                     end:1581073080.000000
                 }
             },
             {
                 number:39,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.994055,
                      time:37980,
                      start:1580751840.000000,
                      end:1580789820.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:44.992780,
                     agitation:1,
                     end:1580800620.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.929111,
                     time:23580,
                     start:1581050160.000000,
                     end:1581073740.000000
                 }
             },
             {
                 number:40,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:904.990566,
                      time:3.822000e+04,
                      start:1580752080.000000,
                      end:1580790300.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:45.003968,
                     agitation:1,
                     end:1580801100.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.942038,
                     time:2.364000e+04,
                     start:1581050880.000000,
                     end:1581074520.000000
                 }
             },
             {
                 number:41,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:912.363109,
                      time:3.828000e+04,
                      start:1580787360.000000,
                      end:1580825640.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.985881,
                     agitation:2,
                     end:1580836440.000000
                 },
                 tempered:{
                     state:0,
                     stateTemp:1,
                     stateTime:0,
                     tempAverage:609.902103,
                     time:18900,
                     start:1581069540.000000,
                     end:1581088440.000000
                 }
             },
             {
                 number:42,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:912.845358,
                      time:38160,
                      start:1580787840.000000,
                      end:1580826000.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.972978,
                     agitation:2,
                     end:1580836800.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.916862,
                     time:23580,
                     start:1581071580.000000,
                     end:1581095160.000000
                 }
             },
             {
                 number:43,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:913.084129,
                      time:37800,
                      start:1580788320.000000,
                      end:1580826120.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.970341,
                     agitation:2,
                     end:1580836920.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.911798,
                     time:2.382000e+04,
                     start:1581072300.000000,
                     end:1581096120.000000
                 }
             },
             {
                 number:44,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:913.370946,
                      time:3.792000e+04,
                      start:1580788440.000000,
                      end:1580826360.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.975703,
                     agitation:2,
                     end:1580837160.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.919370,
                     time:2.370000e+04,
                     start:1581072300.000000,
                     end:1581096000.000000
                 }
             },
             {
                 number:45,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:913.835626,
                      time:3.792000e+04,
                      start:1580788800.000000,
                      end:1580826720.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.986077,
                     agitation:2,
                     end:1580837520.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.922191,
                     time:2.364000e+04,
                     start:1581072300.000000,
                     end:1581095940.000000
                 }
             },
             {
                 number:46,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:914.226884,
                      time:3.792000e+04,
                      start:1580789100.000000,
                      end:1580827020.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.949112,
                     agitation:2,
                     end:1580837820.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.911092,
                     time:23580,
                     start:1581072840.000000,
                     end:1581096420.000000
                 }
             },
             {
                 number:47,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:914.792600,
                      time:3.792000e+04,
                      start:1580789520.000000,
                      end:1580827440.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:44.954875,
                     agitation:2,
                     end:1580838240.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.910079,
                     time:2.352000e+04,
                     start:1581072840.000000,
                     end:1581096360.000000
                 }
             },
             {
                 number:48,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:915.522931,
                      time:3.786000e+04,
                      start:1580790120.000000,
                      end:1580827980.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:45.004396,
                     agitation:2,
                     end:1580838780.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.900448,
                     time:23760,
                     start:1581073380.000000,
                     end:1581097140.000000
                 }
             },
             {
                 number:49,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:915.901579,
                      time:38160,
                      start:1580790180.000000,
                      end:1580828340.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:45.034015,
                     agitation:2,
                     end:1580839140.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.910453,
                     time:2.346000e+04,
                     start:1581074040.000000,
                     end:1581097500.000000
                 }
             },
             {
                 number:50,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:916.621320,
                      time:38340,
                      start:1580790600.000000,
                      end:1580828940.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:45.016552,
                     agitation:2,
                     end:1580839740.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.893577,
                     time:2.364000e+04,
                     start:1581074820.000000,
                     end:1581098460.000000
                 }
             }
         ]
      },
      {
         idOF:2,
         idArticle:1,
         idDesign:2,
         pieces:[
             {
                 number:1,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.847495,
                      time:34380,
                      start:1580825940.000000,
                      end:1580860320
                  },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:50.503557,
                     agitation:3,
                     end:1580864160.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.960290,
                     time:21780,
                     start:1581088740.000000,
                     end:1581110520.000000
                 }
             },
             {
                 number:2,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.861819,
                      time:34380,
                      start:1580826300.000000,
                      end:1580860680.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.925249,
                     agitation:3,
                     end:1580871480.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.924024,
                     time:2.172000e+04,
                     start:1581095460.000000,
                     end:1581117180.000000
                 }
             },
             {
                 number:3,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.864211,
                      time:34740,
                      start:1580826420.000000,
                      end:1580861160.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.950197,
                     agitation:3,
                     end:1580871960.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.951752,
                     time:21960,
                     start:1581096240.000000,
                     end:1581118200.000000
                 }
             },
             {
                 number:4,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.874289,
                      time:3.444000e+04,
                      start:1580826660.000000,
                      end:1580861100.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.952180,
                     agitation:3,
                     end:1580871900.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.955638,
                     time:21960,
                     start:1581096300.000000,
                     end:1581118260.000000
                 }
             },
             {
                 number:5,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.853863,
                      time:3.480000e+04,
                      start:1580827020.000000,
                      end:1580861820.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.910874,
                     agitation:3,
                     end:1580872620.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.959264,
                     time:2.184000e+04,
                     start:1581096420.000000,
                     end:1581118260.000000
                 }
             },
             {
                 number:6,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.848418,
                      time:3.480000e+04,
                      start:1580827320.000000,
                      end:1580862120.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.895811,
                     agitation:3,
                     end:1580872920.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.953742,
                     time:2.190000e+04,
                     start:1581096660.000000,
                     end:1581118560.000000
                 }
             },
             {
                 number:7,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.851450,
                      time:3.426000e+04,
                      start:1580827740.000000,
                      end:1580862000.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.890831,
                     agitation:3,
                     end:1580872800.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.973361,
                     time:21600,
                     start:1581096720.000000,
                     end:1581118320.000000
                 }
             },
             {
                 number:8,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.849873,
                      time:3.468000e+04,
                      start:1580828280.000000,
                      end:1580862960.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.908113,
                     agitation:3,
                     end:1580873760.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.947668,
                     time:2.190000e+04,
                     start:1581097440.000000,
                     end:1581119340.000000
                 }
             },
             {
                 number:9,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.866827,
                      time:34200,
                      start:1580828640.000000,
                      end:1580862840.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.884172,
                     agitation:3,
                     end:1580873640.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.951530,
                     time:21600,
                     start:1581097800.000000,
                     end:1581119400.000000
                 }
             },
             {
                 number:10,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.878923,
                      time:3.480000e+04,
                      start:1580829240.000000,
                      end:1580864040.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.896541,
                     agitation:3,
                     end:1580874840.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.970743,
                     time:21780,
                     start:1581098760.000000,
                     end:1581120540.000000
                 }
             },
             {
                 number:11,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.984508,
                      time:3.426000e+04,
                      start:1580853660.000000,
                      end:1580887920.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.850219,
                     agitation:3,
                     end:1580898720.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.987260,
                     time:21960,
                     start:1581110820.000000,
                     end:1581132780.000000
                 }
             },
             {
                 number:12,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.024234,
                      time:3.426000e+04,
                      start:1580860980.000000,
                      end:1580895240.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.924337,
                     agitation:3,
                     end:1580906040.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.987998,
                     time:2.202000e+04,
                     start:1581117480.000000,
                     end:1581139500.000000
                 }
             },
             {
                 number:13,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.014592,
                      time:3.426000e+04,
                      start:1580861400.000000,
                      end:1580895660.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.939349,
                     agitation:3,
                     end:1580906460.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.987338,
                     time:21600,
                     start:1581118500.000000,
                     end:1581140100.000000
                 }
             },
             {
                 number:14,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.012342,
                      time:3.450000e+04,
                      start:1580861460.000000,
                      end:1580895960.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.956766,
                     agitation:3,
                     end:1580906760.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.986238,
                     time:2.166000e+04,
                     start:1581118560.000000,
                     end:1581140220.000000
                 }
             },
             {
                 number:15,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.012437,
                      time:3.486000e+04,
                      start:1580862120.000000,
                      end:1580896980.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.059561,
                     agitation:3,
                     end:1580907780.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.987420,
                     time:21960,
                     start:1581118560.000000,
                     end:1581140520.000000
                 }
             },
             {
                 number:16,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.015184,
                      time:3.468000e+04,
                      start:1580862300.000000,
                      end:1580896980.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.059561,
                     agitation:3,
                     end:1580907780.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.993945,
                     time:2.166000e+04,
                     start:1581118620.000000,
                     end:1581140280.000000
                 }
             },
             {
                 number:17,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.015622,
                      time:3.426000e+04,
                      start:1580862420.000000,
                      end:1580896680.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.039712,
                     agitation:3,
                     end:1580907480.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.990232,
                     time:2.184000e+04,
                     start:1581118860.000000,
                     end:1581140700.000000
                 }
             },
             {
                 number:18,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.006469,
                      time:34200,
                      start:1580863140.000000,
                      end:1580897340.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.048901,
                     agitation:3,
                     end:1580908140.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.978142,
                     time:21960,
                     start:1581119640.000000,
                     end:1581141600.000000
                 }
             },
             {
                 number:19,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.000983,
                      time:3.480000e+04,
                      start:1580863260.000000,
                      end:1580898060.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.059045,
                     agitation:3,
                     end:1580908860.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.981177,
                     time:2.184000e+04,
                     start:1581119700.000000,
                     end:1581141540.000000
                 }
             },
             {
                 number:20,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.991550,
                      time:34740,
                      start:1580864340.000000,
                      end:1580899080.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.074754,
                     agitation:3,
                     end:1580909880.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.992048,
                     time:21780,
                     start:1581120840.000000,
                     end:1581142620.000000
                 }
             },
             {
                 number:21,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.020321,
                      time:34740,
                      start:1580888220.000000,
                      end:1580922960.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.953950,
                     agitation:3,
                     end:1580933760.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.959012,
                     time:2.184000e+04,
                     start:1581133080.000000,
                     end:1581154920.000000
                 }
             },
             {
                 number:22,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.023022,
                      time:3.486000e+04,
                      start:1580895540.000000,
                      end:1580930400.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.851425,
                     agitation:3,
                     end:1580941200.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.933269,
                     time:2.202000e+04,
                     start:1581139800.000000,
                     end:1581161820.000000
                 }
             },
             {
                 number:23,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.026470,
                      time:3.432000e+04,
                      start:1580895960.000000,
                      end:1580930280.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.850812,
                     agitation:3,
                     end:1580941080.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.936440,
                     time:21960,
                     start:1581140400.000000,
                     end:1581162360.000000
                 }
             },
             {
                 number:24,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.046908,
                      time:3.444000e+04,
                      start:1580896260.000000,
                      end:1580930700.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.836633,
                     agitation:3,
                     end:1580941500.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.944322,
                     time:21600,
                     start:1581140520.000000,
                     end:1581162120.000000
                 }
             },
             {
                 number:25,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.045257,
                      time:34560,
                      start:1580896980.000000,
                      end:1580931540.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.814844,
                     agitation:3,
                     end:1580942340.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.934603,
                     time:2.202000e+04,
                     start:1581140580.000000,
                     end:1581162600.000000
                 }
             },
             {
                 number:26,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.056371,
                      time:3.432000e+04,
                      start:1580897280.000000,
                      end:1580931600.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.816257,
                     agitation:3,
                     end:1580942400.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.951512,
                     time:2.184000e+04,
                     start:1581140820.000000,
                     end:1581162660.000000
                 }
             },
             {
                 number:27,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.054750,
                      time:34380,
                      start:1580897280.000000,
                      end:1580931660.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.808929,
                     agitation:3,
                     end:1580942460.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.955033,
                     time:21780,
                     start:1581141000.000000,
                     end:1581162780.000000
                 }
             },
             {
                 number:28,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.049606,
                      time:3.432000e+04,
                      start:1580897640.000000,
                      end:1580931960.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.834079,
                     agitation:3,
                     end:1580942760.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.965982,
                     time:2.184000e+04,
                     start:1581141840.000000,
                     end:1581163680.000000
                 }
             },
             {
                 number:29,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.029624,
                      time:3.432000e+04,
                      start:1580898360.000000,
                      end:1580932680.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.804729,
                     agitation:3,
                     end:1580943480.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.971886,
                     time:2.202000e+04,
                     start:1581141900.000000,
                     end:1581163920.000000
                 }
             },
             {
                 number:30,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.014085,
                      time:3.432000e+04,
                      start:1580899380.000000,
                      end:1580933700.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.892762,
                     agitation:3,
                     end:1580944500.000000
                 },
                 tempered:{
                     state:0,
                     stateTemp:1,
                     stateTime:0,
                     tempAverage:609.977328,
                     time:17280,
                     start:1581142920.000000,
                     end:1581160200.000000
                 }
             },
             {
                 number:31,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.876744,
                      time:3.462000e+04,
                      start:1580923260.000000,
                      end:1580957880.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.053265,
                     agitation:3,
                     end:1580968680.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.965262,
                     time:2.172000e+04,
                     start:1581155220.000000,
                     end:1581176940.000000
                 }
             },
             {
                 number:32,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.874736,
                      time:34380,
                      start:1580930580.000000,
                      end:1580964960.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.903227,
                     agitation:3,
                     end:1580975760.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.898716,
                     time:2.190000e+04,
                     start:1581160500.000000,
                     end:1581182400.000000
                 }
             },
             {
                 number:33,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.865387,
                      time:3.450000e+04,
                      start:1580930700.000000,
                      end:1580965200.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.930025,
                     agitation:3,
                     end:1580976000.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.874629,
                     time:21780,
                     start:1581162120.000000,
                     end:1581183900.000000
                 }
             },
             {
                 number:34,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.865146,
                      time:3.432000e+04,
                      start:1580931000.000000,
                      end:1580965320.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.928280,
                     agitation:3,
                     end:1580976120.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.865516,
                     time:2.190000e+04,
                     start:1581162420.000000,
                     end:1581184320.000000
                 }
             },
             {
                 number:35,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.870998,
                      time:3.486000e+04,
                      start:1580931840.000000,
                      end:1580966700.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.902647,
                     agitation:3,
                     end:1580977500.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.863610,
                     time:21960,
                     start:1581162660.000000,
                     end:1581184620.000000
                 }
             },
             {
                 number:36,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.867227,
                      time:3.444000e+04,
                      start:1580931900.000000,
                      end:1580966340.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.900569,
                     agitation:3,
                     end:1580977140.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.857602,
                     time:2.190000e+04,
                     start:1581162900.000000,
                     end:1581184800.000000
                 }
             },
             {
                 number:37,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.868616,
                      time:3.480000e+04,
                      start:1580931960.000000,
                      end:1580966760.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.891339,
                     agitation:3,
                     end:1580977560.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.851068,
                     time:2.202000e+04,
                     start:1581162960.000000,
                     end:1581184980.000000
                 }
             },
             {
                 number:38,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.868965,
                      time:3.462000e+04,
                      start:1580932260.000000,
                      end:1580966880.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.881180,
                     agitation:3,
                     end:1580977680.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.858206,
                     time:2.166000e+04,
                     start:1581163080.000000,
                     end:1581184740.000000
                 }
             },
             {
                 number:39,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.887057,
                      time:34740,
                      start:1580932980.000000,
                      end:1580967720.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.941369,
                     agitation:3,
                     end:1580978520.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.841808,
                     time:2.184000e+04,
                     start:1581163980.000000,
                     end:1581185820.000000
                 }
             },
             {
                 number:40,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.887587,
                      time:3.486000e+04,
                      start:1580934000.000000,
                      end:1580968860.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.854875,
                     agitation:3,
                     end:1580979660.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.845713,
                     time:21780,
                     start:1581164220.000000,
                     end:1581186000.000000
                 }
             },
             {
                 number:41,
                 totalState:0,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.006883,
                      time:3.480000e+04,
                      start:1580958180.000000,
                      end:1580992980.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:54.928676,
                     agitation:2,
                     end:1581003780.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.815608,
                     time:2.190000e+04,
                     start:1581177240.000000,
                     end:1581199140.000000
                 }
             },
             {
                 number:42,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.995067,
                      time:3.480000e+04,
                      start:1580965260.000000,
                      end:1581000060.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.001543,
                     agitation:3,
                     end:1581010860.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.841960,
                     time:21960,
                     start:1581182700.000000,
                     end:1581204660.000000
                 }
             },
             {
                 number:43,
                 totalState:0,
                 furnace:{
                      state:0,
                      stateTemp:1,
                      stateTime:0,
                      tempAverage:955.012307,
                      time:2.784000e+04,
                      start:1580965500.000000,
                      end:1580993340.000000
                 },
                 quenching:{
                     state:0,
                     stateTemp:1,
                     stateAgit:0,
                     tempAverage:54.919829,
                     agitation:2,
                     end:1581004140.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.886589,
                     time:2.184000e+04,
                     start:1581184200.000000,
                     end:1581206040.000000
                 }
             },
             {
                 number:44,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.999133,
                      time:3.444000e+04,
                      start:1580965620.000000,
                      end:1581000060.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.001543,
                     agitation:3,
                     end:1581010860.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.903663,
                     time:21960,
                     start:1581184620.000000,
                     end:1581206580.000000
                 }
             },
             {
                 number:45,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.995861,
                      time:3.450000e+04,
                      start:1580966640.000000,
                      end:1581001140.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.000707,
                     agitation:3,
                     end:1581011940.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.916113,
                     time:21960,
                     start:1581184920.000000,
                     end:1581206880.000000
                 }
             },
             {
                 number:46,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.003498,
                      time:3.468000e+04,
                      start:1580967000.000000,
                      end:1581001680.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.997521,
                     agitation:3,
                     end:1581012480.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.904437,
                     time:2.202000e+04,
                     start:1581185040.000000,
                     end:1581207060.000000
                 }
             },
             {
                 number:47,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.007098,
                      time:3.432000e+04,
                      start:1580967060.000000,
                      end:1581001380.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.995326,
                     agitation:3,
                     end:1581012180.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.910051,
                     time:21960,
                     start:1581185100.000000,
                     end:1581207060.000000
                 }
             },
             {
                 number:48,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:955.005101,
                      time:3.450000e+04,
                      start:1580967180.000000,
                      end:1581001680.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.997521,
                     agitation:3,
                     end:1581012480.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.930280,
                     time:2.166000e+04,
                     start:1581185280.000000,
                     end:1581206940.000000
                 }
             },
             {
                 number:49,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.997182,
                      time:3.468000e+04,
                      start:1580968020.000000,
                      end:1581002700.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.943962,
                     agitation:3,
                     end:1581013500.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.895404,
                     time:2.172000e+04,
                     start:1581186120.000000,
                     end:1581207840.000000
                 }
             },
             {
                 number:50,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.988334,
                      time:3.462000e+04,
                      start:1580969160.000000,
                      end:1581003780.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.991634,
                     agitation:3,
                     end:1581014580.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.896688,
                     time:2.172000e+04,
                     start:1581186300.000000,
                     end:1581208020.000000
                 }
             },
             {
                 number:51,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.951780,
                      time:3.480000e+04,
                      start:1580993280.000000,
                      end:1581028080.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.952145,
                     agitation:3,
                     end:1581038880.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.028253,
                     time:2.184000e+04,
                     start:1581199440.000000,
                     end:1581221280.000000
                 }
             },
             {
                 number:52,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.963871,
                      time:3.450000e+04,
                      start:1580993640.000000,
                      end:1581028140.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.949436,
                     agitation:3,
                     end:1581038940.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.026728,
                     time:2.172000e+04,
                     start:1581204960.000000,
                     end:1581226680.000000
                 }
             },
             {
                 number:53,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.942698,
                      time:3.426000e+04,
                      start:1581000360.000000,
                      end:1581034620.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.926378,
                     agitation:3,
                     end:1581045420.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.995565,
                     time:2.184000e+04,
                     start:1581206340.000000,
                     end:1581228180.000000
                 }
             },
             {
                 number:54,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.944387,
                      time:3.450000e+04,
                      start:1581000360.000000,
                      end:1581034860.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.938745,
                     agitation:3,
                     end:1581045660.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.983519,
                     time:21780,
                     start:1581206880.000000,
                     end:1581228660.000000
                 }
             },
             {
                 number:55,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.941208,
                      time:34740,
                      start:1581001440.000000,
                      end:1581036180.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.895162,
                     agitation:3,
                     end:1581046980.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.994288,
                     time:21960,
                     start:1581207180.000000,
                     end:1581229140.000000
                 }
             },
             {
                 number:56,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.942052,
                      time:3.486000e+04,
                      start:1581001680.000000,
                      end:1581036540.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.855356,
                     agitation:3,
                     end:1581047340.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.009123,
                     time:2.172000e+04,
                     start:1581207240.000000,
                     end:1581228960.000000
                 }
             },
             {
                 number:57,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.944733,
                      time:3.486000e+04,
                      start:1581001980.000000,
                      end:1581036840.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.862598,
                     agitation:3,
                     end:1581047640.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.008326,
                     time:2.172000e+04,
                     start:1581207360.000000,
                     end:1581229080.000000
                 }
             },
             {
                 number:58,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.946007,
                      time:34380,
                      start:1581001980.000000,
                      end:1581036360.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.865044,
                     agitation:3,
                     end:1581047160.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:610.003479,
                     time:2.202000e+04,
                     start:1581207360.000000,
                     end:1581229380.000000
                 }
             },
             {
                 number:59,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.960952,
                      time:3.480000e+04,
                      start:1581003000.000000,
                      end:1581037800.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.858482,
                     agitation:3,
                     end:1581048600.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.985239,
                     time:2.184000e+04,
                     start:1581208140.000000,
                     end:1581229980.000000
                 }
             },
             {
                 number:60,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.961665,
                      time:3.486000e+04,
                      start:1581004080.000000,
                      end:1581038940.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.886581,
                     agitation:3,
                     end:1581049740.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.981450,
                     time:2.190000e+04,
                     start:1581208320.000000,
                     end:1581230220.000000
                 }
             },
             {
                 number:61,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.965100,
                      time:3.432000e+04,
                      start:1581028380.000000,
                      end:1581062700.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.882765,
                     agitation:3,
                     end:1581073500.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.895696,
                     time:2.202000e+04,
                     start:1581221580.000000,
                     end:1581243600.000000
                 }
             },
             {
                 number:62,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.967604,
                      time:3.462000e+04,
                      start:1581028440.000000,
                      end:1581063060.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.873654,
                     agitation:3,
                     end:1581073860.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.950029,
                     time:2.172000e+04,
                     start:1581226980.000000,
                     end:1581248700.000000
                 }
             },
             {
                 number:63,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.969861,
                      time:3.450000e+04,
                      start:1581034920.000000,
                      end:1581069420.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.018882,
                     agitation:3,
                     end:1581080220.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.939395,
                     time:2.190000e+04,
                     start:1581228480.000000,
                     end:1581250380.000000
                 }
             },
             {
                 number:64,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.968358,
                      time:3.480000e+04,
                      start:1581035160.000000,
                      end:1581069960.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.014510,
                     agitation:3,
                     end:1581080760.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.954987,
                     time:2.184000e+04,
                     start:1581228960.000000,
                     end:1581250800.000000
                 }
             },
             {
                 number:65,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.967681,
                      time:3.462000e+04,
                      start:1581036480.000000,
                      end:1581071100.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.991841,
                     agitation:3,
                     end:1581081900.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.957902,
                     time:2.172000e+04,
                     start:1581229260.000000,
                     end:1581250980.000000
                 }
             },
             {
                 number:66,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.969931,
                      time:34740,
                      start:1581036660.000000,
                      end:1581071400.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.962802,
                     agitation:3,
                     end:1581082200.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.959804,
                     time:2.190000e+04,
                     start:1581229380.000000,
                     end:1581251280.000000
                 }
             },
             {
                 number:67,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.969638,
                      time:3.444000e+04,
                      start:1581036840.000000,
                      end:1581071280.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.970841,
                     agitation:3,
                     end:1581082080.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.969442,
                     time:2.166000e+04,
                     start:1581229440.000000,
                     end:1581251100.000000
                 }
             },
             {
                 number:68,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.967273,
                      time:3.444000e+04,
                      start:1581037140.000000,
                      end:1581071580.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:54.952402,
                     agitation:3,
                     end:1581082380.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.974181,
                     time:2.172000e+04,
                     start:1581229680.000000,
                     end:1581251400.000000
                 }
             },
             {
                 number:69,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.961762,
                      time:34740,
                      start:1581038100.000000,
                      end:1581072840.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.007599,
                     agitation:3,
                     end:1581083640.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.984540,
                     time:2.184000e+04,
                     start:1581230280.000000,
                     end:1581252120.000000
                 }
             },
             {
                 number:70,
                 totalState:1,
                 furnace:{
                      state:1,
                      stateTemp:1,
                      stateTime:1,
                      tempAverage:954.962473,
                      time:3.480000e+04,
                      start:1581039240.000000,
                      end:1581074040.000000
                 },
                 quenching:{
                     state:1,
                     stateTemp:1,
                     stateAgit:1,
                     tempAverage:55.063269,
                     agitation:3,
                     end:1581084840.000000
                 },
                 tempered:{
                     state:1,
                     stateTemp:1,
                     stateTime:1,
                     tempAverage:609.970200,
                     time:2.172000e+04,
                     start:1581230520.000000,
                     end:1581252240.000000
                 }
             }
         ]
      }
   ],
    temporal:[
      {
         time:1580634000.000000,
         furnaceTemp:900.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580634600.000000,
         furnaceTemp:903.487971,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580635200.000000,
         furnaceTemp:908.199876,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580635800.000000,
         furnaceTemp:906.105558,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580636400.000000,
         furnaceTemp:905.601749,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580637000.000000,
         furnaceTemp:904.039055,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580637600.000000,
         furnaceTemp:903.217323,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580638200.000000,
         furnaceTemp:905.621890,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580638800.000000,
         furnaceTemp:905.753679,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580639400.000000,
         furnaceTemp:904.005909,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580640000.000000,
         furnaceTemp:904.779928,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580640600.000000,
         furnaceTemp:906.021831,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580641200.000000,
         furnaceTemp:904.307078,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580641800.000000,
         furnaceTemp:904.609370,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580642400.000000,
         furnaceTemp:905.603162,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580643000.000000,
         furnaceTemp:903.488011,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580643600.000000,
         furnaceTemp:905.564796,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580644200.000000,
         furnaceTemp:903.186604,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580644800.000000,
         furnaceTemp:903.164610,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580645400.000000,
         furnaceTemp:905.038052,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580646000.000000,
         furnaceTemp:904.005268,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580646600.000000,
         furnaceTemp:903.830061,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580647200.000000,
         furnaceTemp:906.945849,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580647800.000000,
         furnaceTemp:906.145945,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580648400.000000,
         furnaceTemp:903.055139,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580649000.000000,
         furnaceTemp:905.527654,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580649600.000000,
         furnaceTemp:904.600875,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580650200.000000,
         furnaceTemp:906.584090,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580650800.000000,
         furnaceTemp:902.442750,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580651400.000000,
         furnaceTemp:903.889309,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580652000.000000,
         furnaceTemp:901.386506,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580652600.000000,
         furnaceTemp:905.982159,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580653200.000000,
         furnaceTemp:904.549234,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580653800.000000,
         furnaceTemp:904.306285,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580654400.000000,
         furnaceTemp:905.722471,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580655000.000000,
         furnaceTemp:905.608075,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580655600.000000,
         furnaceTemp:904.953675,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580656200.000000,
         furnaceTemp:903.980617,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580656800.000000,
         furnaceTemp:905.844945,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580657400.000000,
         furnaceTemp:905.175401,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580658000.000000,
         furnaceTemp:903.706277,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580658600.000000,
         furnaceTemp:904.260529,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580659200.000000,
         furnaceTemp:906.252114,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580659800.000000,
         furnaceTemp:902.974157,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580660400.000000,
         furnaceTemp:902.748476,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580661000.000000,
         furnaceTemp:905.133415,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580661600.000000,
         furnaceTemp:904.883804,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580662200.000000,
         furnaceTemp:905.232908,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580662800.000000,
         furnaceTemp:904.628628,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580663400.000000,
         furnaceTemp:905.394885,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580664000.000000,
         furnaceTemp:905.509194,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580664600.000000,
         furnaceTemp:903.997971,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580665200.000000,
         furnaceTemp:904.964115,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580665800.000000,
         furnaceTemp:904.519140,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580666400.000000,
         furnaceTemp:904.789650,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580667000.000000,
         furnaceTemp:906.038433,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580667600.000000,
         furnaceTemp:904.490351,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580668200.000000,
         furnaceTemp:906.182234,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580668800.000000,
         furnaceTemp:905.079737,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580669400.000000,
         furnaceTemp:904.757466,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580670000.000000,
         furnaceTemp:905.357043,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580670600.000000,
         furnaceTemp:907.257462,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580671200.000000,
         furnaceTemp:906.571987,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580671800.000000,
         furnaceTemp:904.724144,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:0.000000,
      },
      {
         time:1580672220.000000,
         furnaceTemp:906.515154,
         quenchingTemp:40.000000,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580672820.000000,
         furnaceTemp:905.606012,
         quenchingTemp:43.375554,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580673420.000000,
         furnaceTemp:903.583080,
         quenchingTemp:47.138598,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580674020.000000,
         furnaceTemp:905.560712,
         quenchingTemp:46.114959,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580674620.000000,
         furnaceTemp:905.945397,
         quenchingTemp:45.615501,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580675220.000000,
         furnaceTemp:905.086935,
         quenchingTemp:44.039796,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580675820.000000,
         furnaceTemp:903.786814,
         quenchingTemp:43.213884,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580676420.000000,
         furnaceTemp:902.734371,
         quenchingTemp:45.617895,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580677020.000000,
         furnaceTemp:905.199909,
         quenchingTemp:45.752158,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580677620.000000,
         furnaceTemp:905.706227,
         quenchingTemp:44.006238,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580678220.000000,
         furnaceTemp:906.199970,
         quenchingTemp:44.783750,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580678820.000000,
         furnaceTemp:904.821813,
         quenchingTemp:46.009990,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580679420.000000,
         furnaceTemp:905.012202,
         quenchingTemp:44.306042,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580680020.000000,
         furnaceTemp:903.571879,
         quenchingTemp:44.601633,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580680620.000000,
         furnaceTemp:903.893840,
         quenchingTemp:45.605483,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580681220.000000,
         furnaceTemp:904.793515,
         quenchingTemp:43.484902,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580681820.000000,
         furnaceTemp:905.767861,
         quenchingTemp:45.572053,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580682420.000000,
         furnaceTemp:905.895359,
         quenchingTemp:43.181528,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580683020.000000,
         furnaceTemp:905.042268,
         quenchingTemp:43.161182,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580683620.000000,
         furnaceTemp:905.694889,
         quenchingTemp:44.916659,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580684220.000000,
         furnaceTemp:904.954202,
         quenchingTemp:42.942887,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580684820.000000,
         furnaceTemp:905.402433,
         quenchingTemp:43.831909,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580685420.000000,
         furnaceTemp:905.621246,
         quenchingTemp:46.947399,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580686020.000000,
         furnaceTemp:907.320993,
         quenchingTemp:46.136332,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580686620.000000,
         furnaceTemp:906.385904,
         quenchingTemp:43.054388,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580687220.000000,
         furnaceTemp:906.365003,
         quenchingTemp:45.521527,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580687820.000000,
         furnaceTemp:902.908471,
         quenchingTemp:44.603939,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580688420.000000,
         furnaceTemp:905.015138,
         quenchingTemp:46.589732,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580689020.000000,
         furnaceTemp:904.955608,
         quenchingTemp:42.459320,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580689620.000000,
         furnaceTemp:904.998496,
         quenchingTemp:43.883003,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580690220.000000,
         furnaceTemp:905.572913,
         quenchingTemp:41.390025,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580690820.000000,
         furnaceTemp:904.399134,
         quenchingTemp:45.987071,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580691420.000000,
         furnaceTemp:904.216210,
         quenchingTemp:44.549071,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580692020.000000,
         furnaceTemp:906.261464,
         quenchingTemp:44.312856,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580692620.000000,
         furnaceTemp:906.824341,
         quenchingTemp:45.713376,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580693220.000000,
         furnaceTemp:903.661670,
         quenchingTemp:45.600187,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580693820.000000,
         furnaceTemp:905.954135,
         quenchingTemp:44.952976,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580694420.000000,
         furnaceTemp:904.188431,
         quenchingTemp:43.983166,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580695020.000000,
         furnaceTemp:904.663753,
         quenchingTemp:45.845874,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580695620.000000,
         furnaceTemp:905.706244,
         quenchingTemp:45.174038,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580696220.000000,
         furnaceTemp:905.247430,
         quenchingTemp:43.712800,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580696820.000000,
         furnaceTemp:905.535326,
         quenchingTemp:44.251361,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580697420.000000,
         furnaceTemp:904.055953,
         quenchingTemp:46.261108,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580698020.000000,
         furnaceTemp:904.288239,
         quenchingTemp:42.970168,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580698620.000000,
         furnaceTemp:904.055590,
         quenchingTemp:42.751060,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580699220.000000,
         furnaceTemp:903.355033,
         quenchingTemp:45.134361,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580699820.000000,
         furnaceTemp:905.090990,
         quenchingTemp:44.882132,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580700420.000000,
         furnaceTemp:902.836886,
         quenchingTemp:45.241411,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580701020.000000,
         furnaceTemp:903.992153,
         quenchingTemp:44.623618,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580701620.000000,
         furnaceTemp:905.618909,
         quenchingTemp:45.394228,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580702220.000000,
         furnaceTemp:905.065019,
         quenchingTemp:45.507486,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580702820.000000,
         furnaceTemp:905.953919,
         quenchingTemp:43.995979,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580703420.000000,
         furnaceTemp:906.825966,
         quenchingTemp:44.958523,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580704020.000000,
         furnaceTemp:903.325851,
         quenchingTemp:44.516919,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580704620.000000,
         furnaceTemp:904.903383,
         quenchingTemp:44.788309,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580705220.000000,
         furnaceTemp:905.781094,
         quenchingTemp:46.037626,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580705820.000000,
         furnaceTemp:905.246915,
         quenchingTemp:44.498131,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580706420.000000,
         furnaceTemp:904.245036,
         quenchingTemp:46.181424,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580707020.000000,
         furnaceTemp:905.727119,
         quenchingTemp:45.075434,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580707620.000000,
         furnaceTemp:903.929764,
         quenchingTemp:44.757262,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580708220.000000,
         furnaceTemp:904.568455,
         quenchingTemp:45.348380,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580708820.000000,
         furnaceTemp:906.383265,
         quenchingTemp:47.254109,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580709420.000000,
         furnaceTemp:904.906451,
         quenchingTemp:46.571684,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580710020.000000,
         furnaceTemp:903.269670,
         quenchingTemp:44.726951,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580710620.000000,
         furnaceTemp:901.990911,
         quenchingTemp:43.578016,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580711220.000000,
         furnaceTemp:906.057861,
         quenchingTemp:45.178504,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580711820.000000,
         furnaceTemp:904.201100,
         quenchingTemp:46.003383,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580712420.000000,
         furnaceTemp:904.163331,
         quenchingTemp:44.932072,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580713020.000000,
         furnaceTemp:903.938374,
         quenchingTemp:43.163512,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580713620.000000,
         furnaceTemp:904.421937,
         quenchingTemp:44.284992,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580714220.000000,
         furnaceTemp:903.645558,
         quenchingTemp:45.735892,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580714820.000000,
         furnaceTemp:902.662083,
         quenchingTemp:44.449576,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580715420.000000,
         furnaceTemp:903.092453,
         quenchingTemp:46.062523,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580716020.000000,
         furnaceTemp:903.412332,
         quenchingTemp:45.250420,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580716620.000000,
         furnaceTemp:904.134692,
         quenchingTemp:47.489702,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580717220.000000,
         furnaceTemp:906.525057,
         quenchingTemp:44.422330,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580717820.000000,
         furnaceTemp:905.948240,
         quenchingTemp:45.897576,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580718420.000000,
         furnaceTemp:904.414622,
         quenchingTemp:44.828360,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580719020.000000,
         furnaceTemp:906.314028,
         quenchingTemp:46.311258,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580719620.000000,
         furnaceTemp:904.680107,
         quenchingTemp:45.441319,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580720220.000000,
         furnaceTemp:905.993499,
         quenchingTemp:45.334794,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580720820.000000,
         furnaceTemp:906.745655,
         quenchingTemp:42.787253,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580721420.000000,
         furnaceTemp:907.075025,
         quenchingTemp:45.804339,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580722020.000000,
         furnaceTemp:904.473324,
         quenchingTemp:43.999848,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580722620.000000,
         furnaceTemp:904.525029,
         quenchingTemp:44.054656,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580723220.000000,
         furnaceTemp:905.147609,
         quenchingTemp:44.871593,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580723820.000000,
         furnaceTemp:904.313987,
         quenchingTemp:45.979565,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580724420.000000,
         furnaceTemp:905.087036,
         quenchingTemp:45.422772,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580725020.000000,
         furnaceTemp:904.580871,
         quenchingTemp:44.903097,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580725620.000000,
         furnaceTemp:904.603717,
         quenchingTemp:43.870120,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580726220.000000,
         furnaceTemp:904.820706,
         quenchingTemp:45.523504,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580726820.000000,
         furnaceTemp:906.090427,
         quenchingTemp:45.803717,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580727420.000000,
         furnaceTemp:905.616575,
         quenchingTemp:45.511236,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580728020.000000,
         furnaceTemp:905.668511,
         quenchingTemp:44.762048,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580728620.000000,
         furnaceTemp:903.845838,
         quenchingTemp:44.675129,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580729220.000000,
         furnaceTemp:906.335304,
         quenchingTemp:45.560524,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580729820.000000,
         furnaceTemp:903.131996,
         quenchingTemp:44.295235,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580730420.000000,
         furnaceTemp:907.415005,
         quenchingTemp:46.916149,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580731020.000000,
         furnaceTemp:904.339567,
         quenchingTemp:44.323230,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580731620.000000,
         furnaceTemp:904.467761,
         quenchingTemp:45.880608,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580732220.000000,
         furnaceTemp:904.747488,
         quenchingTemp:44.801200,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580732820.000000,
         furnaceTemp:905.094089,
         quenchingTemp:44.299823,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580733420.000000,
         furnaceTemp:904.582388,
         quenchingTemp:45.490816,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580734020.000000,
         furnaceTemp:904.283544,
         quenchingTemp:45.195930,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580734620.000000,
         furnaceTemp:905.245141,
         quenchingTemp:44.543257,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580735220.000000,
         furnaceTemp:905.656241,
         quenchingTemp:45.060112,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580735820.000000,
         furnaceTemp:904.373889,
         quenchingTemp:42.749660,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580736420.000000,
         furnaceTemp:905.433312,
         quenchingTemp:43.973156,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580737020.000000,
         furnaceTemp:905.716087,
         quenchingTemp:44.503772,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580737620.000000,
         furnaceTemp:904.976030,
         quenchingTemp:43.002425,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580738220.000000,
         furnaceTemp:904.707725,
         quenchingTemp:45.490162,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580738820.000000,
         furnaceTemp:904.726411,
         quenchingTemp:44.480707,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580739420.000000,
         furnaceTemp:903.804255,
         quenchingTemp:45.027311,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580740020.000000,
         furnaceTemp:906.118331,
         quenchingTemp:44.392114,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580740620.000000,
         furnaceTemp:905.061901,
         quenchingTemp:43.637655,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580741220.000000,
         furnaceTemp:905.096798,
         quenchingTemp:45.858019,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580741820.000000,
         furnaceTemp:902.840867,
         quenchingTemp:46.374550,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580742420.000000,
         furnaceTemp:906.047282,
         quenchingTemp:44.558123,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580743020.000000,
         furnaceTemp:902.730493,
         quenchingTemp:45.517480,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580743620.000000,
         furnaceTemp:905.301552,
         quenchingTemp:47.256978,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580744220.000000,
         furnaceTemp:903.860644,
         quenchingTemp:46.928197,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580744820.000000,
         furnaceTemp:904.818776,
         quenchingTemp:42.894026,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580745420.000000,
         furnaceTemp:904.517541,
         quenchingTemp:44.778650,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580746020.000000,
         furnaceTemp:905.602791,
         quenchingTemp:43.796894,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580746620.000000,
         furnaceTemp:903.457163,
         quenchingTemp:44.969196,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580747220.000000,
         furnaceTemp:906.025012,
         quenchingTemp:43.765865,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580747820.000000,
         furnaceTemp:904.715318,
         quenchingTemp:44.126339,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580748420.000000,
         furnaceTemp:905.053972,
         quenchingTemp:43.460078,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580749020.000000,
         furnaceTemp:905.395530,
         quenchingTemp:45.353905,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580749620.000000,
         furnaceTemp:903.066057,
         quenchingTemp:43.854556,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580750220.000000,
         furnaceTemp:905.319482,
         quenchingTemp:45.920064,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580750820.000000,
         furnaceTemp:905.150999,
         quenchingTemp:46.045847,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580751420.000000,
         furnaceTemp:905.890692,
         quenchingTemp:43.677280,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580752020.000000,
         furnaceTemp:904.425188,
         quenchingTemp:44.564909,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580752620.000000,
         furnaceTemp:908.543042,
         quenchingTemp:46.269508,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580753220.000000,
         furnaceTemp:904.524553,
         quenchingTemp:45.508056,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580753820.000000,
         furnaceTemp:904.136584,
         quenchingTemp:45.249543,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580754420.000000,
         furnaceTemp:906.487451,
         quenchingTemp:43.037439,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580755020.000000,
         furnaceTemp:906.979035,
         quenchingTemp:43.113080,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580755620.000000,
         furnaceTemp:905.536894,
         quenchingTemp:44.542529,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580756220.000000,
         furnaceTemp:904.697163,
         quenchingTemp:45.465598,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580756820.000000,
         furnaceTemp:905.403169,
         quenchingTemp:45.432842,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580757420.000000,
         furnaceTemp:903.468640,
         quenchingTemp:44.097331,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580758020.000000,
         furnaceTemp:905.911008,
         quenchingTemp:45.913126,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580758620.000000,
         furnaceTemp:904.153993,
         quenchingTemp:45.447292,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580759220.000000,
         furnaceTemp:905.454393,
         quenchingTemp:45.699249,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580759820.000000,
         furnaceTemp:906.457695,
         quenchingTemp:46.680500,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580760420.000000,
         furnaceTemp:906.765864,
         quenchingTemp:45.572421,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580761020.000000,
         furnaceTemp:905.958803,
         quenchingTemp:44.005664,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580761620.000000,
         furnaceTemp:904.269128,
         quenchingTemp:43.373667,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580762220.000000,
         furnaceTemp:905.002876,
         quenchingTemp:46.464822,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580762820.000000,
         furnaceTemp:905.849904,
         quenchingTemp:45.349111,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580763420.000000,
         furnaceTemp:904.799153,
         quenchingTemp:46.108062,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580764020.000000,
         furnaceTemp:906.859998,
         quenchingTemp:45.844056,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580764620.000000,
         furnaceTemp:903.114159,
         quenchingTemp:45.455974,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580765220.000000,
         furnaceTemp:904.199986,
         quenchingTemp:45.744273,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580765820.000000,
         furnaceTemp:904.784413,
         quenchingTemp:47.118245,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580766420.000000,
         furnaceTemp:904.154330,
         quenchingTemp:44.394917,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580767020.000000,
         furnaceTemp:904.612667,
         quenchingTemp:45.451720,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580767620.000000,
         furnaceTemp:904.615959,
         quenchingTemp:45.174488,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580768220.000000,
         furnaceTemp:904.123040,
         quenchingTemp:46.403542,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580768820.000000,
         furnaceTemp:904.453296,
         quenchingTemp:45.187885,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580769420.000000,
         furnaceTemp:905.943197,
         quenchingTemp:46.308936,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580770020.000000,
         furnaceTemp:903.424585,
         quenchingTemp:44.809985,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580770620.000000,
         furnaceTemp:903.255441,
         quenchingTemp:44.688009,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580771220.000000,
         furnaceTemp:904.544042,
         quenchingTemp:43.767761,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580771820.000000,
         furnaceTemp:903.795516,
         quenchingTemp:44.627882,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580772420.000000,
         furnaceTemp:905.410810,
         quenchingTemp:44.932846,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580773020.000000,
         furnaceTemp:905.274491,
         quenchingTemp:45.361970,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580773620.000000,
         furnaceTemp:905.820213,
         quenchingTemp:45.004666,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580774220.000000,
         furnaceTemp:904.143308,
         quenchingTemp:43.501479,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580774820.000000,
         furnaceTemp:903.901494,
         quenchingTemp:45.774498,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580775420.000000,
         furnaceTemp:906.545514,
         quenchingTemp:44.060796,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580776020.000000,
         furnaceTemp:904.237395,
         quenchingTemp:44.825303,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580776620.000000,
         furnaceTemp:905.478589,
         quenchingTemp:47.093934,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580777220.000000,
         furnaceTemp:905.775743,
         quenchingTemp:45.618943,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580777820.000000,
         furnaceTemp:906.003542,
         quenchingTemp:43.629172,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580778420.000000,
         furnaceTemp:906.232336,
         quenchingTemp:46.034940,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580779020.000000,
         furnaceTemp:907.049320,
         quenchingTemp:43.518132,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580779620.000000,
         furnaceTemp:904.429865,
         quenchingTemp:45.806879,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580780220.000000,
         furnaceTemp:906.710191,
         quenchingTemp:44.749677,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580780820.000000,
         furnaceTemp:905.355181,
         quenchingTemp:45.085042,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580781420.000000,
         furnaceTemp:903.722553,
         quenchingTemp:43.034168,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580782020.000000,
         furnaceTemp:905.858575,
         quenchingTemp:46.257017,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580782620.000000,
         furnaceTemp:905.496281,
         quenchingTemp:46.190091,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580783220.000000,
         furnaceTemp:904.955553,
         quenchingTemp:46.524486,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580783820.000000,
         furnaceTemp:904.279440,
         quenchingTemp:47.231162,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580784420.000000,
         furnaceTemp:904.926016,
         quenchingTemp:44.751725,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580785020.000000,
         furnaceTemp:903.879537,
         quenchingTemp:45.550865,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580785620.000000,
         furnaceTemp:905.036999,
         quenchingTemp:45.103295,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580786220.000000,
         furnaceTemp:903.440918,
         quenchingTemp:46.262474,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580786820.000000,
         furnaceTemp:905.483116,
         quenchingTemp:43.222376,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580787420.000000,
         furnaceTemp:905.602655,
         quenchingTemp:44.435133,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580788020.000000,
         furnaceTemp:904.121267,
         quenchingTemp:45.026977,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580788620.000000,
         furnaceTemp:902.989918,
         quenchingTemp:42.706753,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580789220.000000,
         furnaceTemp:904.746586,
         quenchingTemp:46.442823,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580789820.000000,
         furnaceTemp:905.186635,
         quenchingTemp:44.633204,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580790420.000000,
         furnaceTemp:903.644377,
         quenchingTemp:43.396330,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580791020.000000,
         furnaceTemp:905.459589,
         quenchingTemp:46.237830,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580791620.000000,
         furnaceTemp:904.834569,
         quenchingTemp:44.772001,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580792220.000000,
         furnaceTemp:903.952451,
         quenchingTemp:43.805914,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580792820.000000,
         furnaceTemp:905.400412,
         quenchingTemp:43.324508,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580793420.000000,
         furnaceTemp:904.093798,
         quenchingTemp:44.472685,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580794020.000000,
         furnaceTemp:905.754477,
         quenchingTemp:45.273907,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580794620.000000,
         furnaceTemp:905.350338,
         quenchingTemp:43.193727,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580795220.000000,
         furnaceTemp:904.224682,
         quenchingTemp:43.923905,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580795820.000000,
         furnaceTemp:905.352613,
         quenchingTemp:43.475816,
         quenchingAgit:1,
         temperedTemp:0.000000,
      },
      {
         time:1580796420.000000,
         furnaceTemp:902.854396,
         quenchingTemp:44.338576,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580797020.000000,
         furnaceTemp:905.066069,
         quenchingTemp:44.990558,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580797620.000000,
         furnaceTemp:904.330174,
         quenchingTemp:43.778769,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580798220.000000,
         furnaceTemp:905.123080,
         quenchingTemp:45.329239,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580798820.000000,
         furnaceTemp:903.927117,
         quenchingTemp:44.982956,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580799420.000000,
         furnaceTemp:903.686799,
         quenchingTemp:43.647670,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580800020.000000,
         furnaceTemp:906.769522,
         quenchingTemp:45.296042,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580800620.000000,
         furnaceTemp:906.294239,
         quenchingTemp:42.954037,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580801220.000000,
         furnaceTemp:906.038905,
         quenchingTemp:45.316504,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580801820.000000,
         furnaceTemp:905.250632,
         quenchingTemp:43.923219,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580802420.000000,
         furnaceTemp:904.098228,
         quenchingTemp:46.462976,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580803020.000000,
         furnaceTemp:905.473010,
         quenchingTemp:43.659076,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580803620.000000,
         furnaceTemp:904.143851,
         quenchingTemp:44.530948,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580804220.000000,
         furnaceTemp:904.144314,
         quenchingTemp:44.333162,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580804820.000000,
         furnaceTemp:905.146066,
         quenchingTemp:45.515212,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580805420.000000,
         furnaceTemp:904.215431,
         quenchingTemp:45.022236,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580806020.000000,
         furnaceTemp:906.088177,
         quenchingTemp:44.806282,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580806620.000000,
         furnaceTemp:904.838432,
         quenchingTemp:44.325606,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580807220.000000,
         furnaceTemp:903.250431,
         quenchingTemp:45.113747,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580807820.000000,
         furnaceTemp:904.106855,
         quenchingTemp:43.434162,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580808420.000000,
         furnaceTemp:904.639493,
         quenchingTemp:44.360336,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580809020.000000,
         furnaceTemp:904.540698,
         quenchingTemp:45.478756,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580809620.000000,
         furnaceTemp:901.910854,
         quenchingTemp:45.724873,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580810220.000000,
         furnaceTemp:904.132662,
         quenchingTemp:47.126886,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580810820.000000,
         furnaceTemp:906.417535,
         quenchingTemp:46.296685,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580811420.000000,
         furnaceTemp:906.816015,
         quenchingTemp:44.935768,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580812020.000000,
         furnaceTemp:903.982283,
         quenchingTemp:45.687747,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580812620.000000,
         furnaceTemp:905.083938,
         quenchingTemp:45.695317,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580813220.000000,
         furnaceTemp:902.220156,
         quenchingTemp:45.857447,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580813820.000000,
         furnaceTemp:903.519332,
         quenchingTemp:43.832686,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580814420.000000,
         furnaceTemp:905.159661,
         quenchingTemp:46.085164,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580815020.000000,
         furnaceTemp:903.471942,
         quenchingTemp:44.406013,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580815620.000000,
         furnaceTemp:905.148580,
         quenchingTemp:45.361858,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580816220.000000,
         furnaceTemp:905.028054,
         quenchingTemp:44.843268,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580816820.000000,
         furnaceTemp:905.132665,
         quenchingTemp:43.797917,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580817420.000000,
         furnaceTemp:905.088664,
         quenchingTemp:46.768979,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580818020.000000,
         furnaceTemp:902.940501,
         quenchingTemp:45.473128,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580818620.000000,
         furnaceTemp:904.538219,
         quenchingTemp:45.033108,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580819220.000000,
         furnaceTemp:905.498603,
         quenchingTemp:45.469675,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580819820.000000,
         furnaceTemp:905.012835,
         quenchingTemp:45.068436,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580820420.000000,
         furnaceTemp:955.540182,
         quenchingTemp:46.093269,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580821020.000000,
         furnaceTemp:956.290354,
         quenchingTemp:45.352276,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580821620.000000,
         furnaceTemp:955.133647,
         quenchingTemp:43.851675,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580822220.000000,
         furnaceTemp:956.065494,
         quenchingTemp:46.340622,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580822820.000000,
         furnaceTemp:956.089936,
         quenchingTemp:45.125058,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580823420.000000,
         furnaceTemp:954.572895,
         quenchingTemp:43.917732,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580824020.000000,
         furnaceTemp:955.934815,
         quenchingTemp:45.976044,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580824620.000000,
         furnaceTemp:952.173680,
         quenchingTemp:46.047663,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580825220.000000,
         furnaceTemp:955.278922,
         quenchingTemp:44.955428,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580825820.000000,
         furnaceTemp:955.236550,
         quenchingTemp:45.827032,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580826420.000000,
         furnaceTemp:953.074231,
         quenchingTemp:44.013825,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580827020.000000,
         furnaceTemp:953.996688,
         quenchingTemp:45.524675,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580827620.000000,
         furnaceTemp:955.195495,
         quenchingTemp:45.114525,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580828220.000000,
         furnaceTemp:955.822647,
         quenchingTemp:44.422309,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580828820.000000,
         furnaceTemp:954.937411,
         quenchingTemp:45.840401,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580829420.000000,
         furnaceTemp:954.800821,
         quenchingTemp:46.390978,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580830020.000000,
         furnaceTemp:954.145490,
         quenchingTemp:45.477136,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580830620.000000,
         furnaceTemp:954.476448,
         quenchingTemp:46.760122,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580831220.000000,
         furnaceTemp:955.951460,
         quenchingTemp:43.472061,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580831820.000000,
         furnaceTemp:953.667673,
         quenchingTemp:46.087037,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580832420.000000,
         furnaceTemp:956.644414,
         quenchingTemp:44.825873,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580833020.000000,
         furnaceTemp:955.191440,
         quenchingTemp:44.891264,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580833620.000000,
         furnaceTemp:957.695927,
         quenchingTemp:44.271016,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580834220.000000,
         furnaceTemp:954.822279,
         quenchingTemp:46.047228,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580834820.000000,
         furnaceTemp:955.655645,
         quenchingTemp:44.231642,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580835420.000000,
         furnaceTemp:952.966626,
         quenchingTemp:44.250857,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580836020.000000,
         furnaceTemp:955.285992,
         quenchingTemp:45.780871,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580836620.000000,
         furnaceTemp:955.473116,
         quenchingTemp:45.931469,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580837220.000000,
         furnaceTemp:954.993182,
         quenchingTemp:43.886352,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580837820.000000,
         furnaceTemp:953.338024,
         quenchingTemp:45.435823,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580838420.000000,
         furnaceTemp:954.687243,
         quenchingTemp:42.663246,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580839020.000000,
         furnaceTemp:954.254518,
         quenchingTemp:46.474661,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580839620.000000,
         furnaceTemp:954.834414,
         quenchingTemp:44.046332,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580840220.000000,
         furnaceTemp:954.303311,
         quenchingTemp:42.812272,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580840820.000000,
         furnaceTemp:955.406093,
         quenchingTemp:47.099434,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580841420.000000,
         furnaceTemp:954.206506,
         quenchingTemp:45.813467,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580842020.000000,
         furnaceTemp:954.304985,
         quenchingTemp:44.319411,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580842620.000000,
         furnaceTemp:953.717586,
         quenchingTemp:45.968167,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580843220.000000,
         furnaceTemp:956.504228,
         quenchingTemp:45.820087,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580843820.000000,
         furnaceTemp:954.909347,
         quenchingTemp:46.072586,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580844420.000000,
         furnaceTemp:956.594618,
         quenchingTemp:45.715339,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580845020.000000,
         furnaceTemp:955.876159,
         quenchingTemp:44.372132,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580845620.000000,
         furnaceTemp:956.392934,
         quenchingTemp:45.669006,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580846220.000000,
         furnaceTemp:954.527811,
         quenchingTemp:44.830183,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580846820.000000,
         furnaceTemp:956.277862,
         quenchingTemp:45.106232,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580847420.000000,
         furnaceTemp:955.824374,
         quenchingTemp:45.616123,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580848020.000000,
         furnaceTemp:955.501499,
         quenchingTemp:45.821192,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580848620.000000,
         furnaceTemp:954.752446,
         quenchingTemp:43.924060,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580849220.000000,
         furnaceTemp:955.036279,
         quenchingTemp:45.734748,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580849820.000000,
         furnaceTemp:956.238459,
         quenchingTemp:45.877763,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580850420.000000,
         furnaceTemp:955.894128,
         quenchingTemp:44.875010,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580851020.000000,
         furnaceTemp:953.903892,
         quenchingTemp:44.004084,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580851620.000000,
         furnaceTemp:953.007619,
         quenchingTemp:44.235613,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580852220.000000,
         furnaceTemp:955.015067,
         quenchingTemp:42.967065,
         quenchingAgit:2,
         temperedTemp:0.000000,
      },
      {
         time:1580852820.000000,
         furnaceTemp:953.379115,
         quenchingTemp:44.190127,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580853420.000000,
         furnaceTemp:955.825253,
         quenchingTemp:45.526912,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580854020.000000,
         furnaceTemp:955.223364,
         quenchingTemp:44.753303,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580854620.000000,
         furnaceTemp:954.591453,
         quenchingTemp:45.473027,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580855220.000000,
         furnaceTemp:952.806169,
         quenchingTemp:44.726205,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580855820.000000,
         furnaceTemp:956.112521,
         quenchingTemp:45.663929,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580856420.000000,
         furnaceTemp:955.043159,
         quenchingTemp:44.784166,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580857020.000000,
         furnaceTemp:954.810948,
         quenchingTemp:45.399209,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580857620.000000,
         furnaceTemp:953.288661,
         quenchingTemp:45.607915,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580858220.000000,
         furnaceTemp:954.795641,
         quenchingTemp:47.409913,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580858820.000000,
         furnaceTemp:955.774529,
         quenchingTemp:54.242428,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580859420.000000,
         furnaceTemp:956.251827,
         quenchingTemp:52.305559,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580860020.000000,
         furnaceTemp:955.948991,
         quenchingTemp:56.952566,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580860620.000000,
         furnaceTemp:955.693946,
         quenchingTemp:53.765591,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580861220.000000,
         furnaceTemp:953.766270,
         quenchingTemp:54.317495,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580861820.000000,
         furnaceTemp:953.984610,
         quenchingTemp:56.155082,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580862420.000000,
         furnaceTemp:951.717038,
         quenchingTemp:55.154143,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580863020.000000,
         furnaceTemp:955.873270,
         quenchingTemp:54.901918,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580863620.000000,
         furnaceTemp:954.535703,
         quenchingTemp:53.836827,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580864220.000000,
         furnaceTemp:954.969980,
         quenchingTemp:52.243125,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580864820.000000,
         furnaceTemp:955.163682,
         quenchingTemp:53.726936,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580865420.000000,
         furnaceTemp:953.232247,
         quenchingTemp:57.058465,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580866020.000000,
         furnaceTemp:954.814264,
         quenchingTemp:54.684463,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580866620.000000,
         furnaceTemp:956.580330,
         quenchingTemp:54.101400,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580867220.000000,
         furnaceTemp:954.432664,
         quenchingTemp:56.142894,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580867820.000000,
         furnaceTemp:953.968636,
         quenchingTemp:55.074474,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580868420.000000,
         furnaceTemp:955.179080,
         quenchingTemp:55.279314,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580869020.000000,
         furnaceTemp:956.966723,
         quenchingTemp:55.456030,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580869620.000000,
         furnaceTemp:956.138603,
         quenchingTemp:58.122314,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580870220.000000,
         furnaceTemp:954.850948,
         quenchingTemp:56.193451,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580870820.000000,
         furnaceTemp:955.497078,
         quenchingTemp:56.246018,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580871420.000000,
         furnaceTemp:955.469520,
         quenchingTemp:55.476374,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580872020.000000,
         furnaceTemp:955.173523,
         quenchingTemp:54.005243,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580872620.000000,
         furnaceTemp:955.148602,
         quenchingTemp:53.172143,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580873220.000000,
         furnaceTemp:954.946289,
         quenchingTemp:56.330429,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580873820.000000,
         furnaceTemp:955.358611,
         quenchingTemp:54.371153,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580874420.000000,
         furnaceTemp:954.852884,
         quenchingTemp:55.645609,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580875020.000000,
         furnaceTemp:956.274624,
         quenchingTemp:54.703553,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580875620.000000,
         furnaceTemp:953.660334,
         quenchingTemp:55.208221,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580876220.000000,
         furnaceTemp:955.000800,
         quenchingTemp:52.957425,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580876820.000000,
         furnaceTemp:955.201158,
         quenchingTemp:56.142686,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580877420.000000,
         furnaceTemp:956.058892,
         quenchingTemp:54.692699,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580878020.000000,
         furnaceTemp:957.322203,
         quenchingTemp:54.726050,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580878620.000000,
         furnaceTemp:952.903542,
         quenchingTemp:54.922699,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580879220.000000,
         furnaceTemp:955.132684,
         quenchingTemp:54.782578,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580879820.000000,
         furnaceTemp:955.251578,
         quenchingTemp:55.131882,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580880420.000000,
         furnaceTemp:956.495422,
         quenchingTemp:54.237667,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580881020.000000,
         furnaceTemp:953.041615,
         quenchingTemp:54.887699,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580881620.000000,
         furnaceTemp:954.620565,
         quenchingTemp:54.352846,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580882220.000000,
         furnaceTemp:956.790024,
         quenchingTemp:55.687141,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580882820.000000,
         furnaceTemp:955.061462,
         quenchingTemp:52.890033,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580883420.000000,
         furnaceTemp:956.614433,
         quenchingTemp:56.142803,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580884020.000000,
         furnaceTemp:955.564449,
         quenchingTemp:54.955792,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580884620.000000,
         furnaceTemp:953.863141,
         quenchingTemp:56.021452,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580885220.000000,
         furnaceTemp:954.903196,
         quenchingTemp:56.598421,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580885820.000000,
         furnaceTemp:954.239523,
         quenchingTemp:53.305625,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580886420.000000,
         furnaceTemp:955.678467,
         quenchingTemp:55.642787,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580887020.000000,
         furnaceTemp:954.169786,
         quenchingTemp:55.164773,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580887620.000000,
         furnaceTemp:954.401999,
         quenchingTemp:53.881148,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580888220.000000,
         furnaceTemp:955.134104,
         quenchingTemp:55.707861,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580888820.000000,
         furnaceTemp:955.479075,
         quenchingTemp:52.576171,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580889420.000000,
         furnaceTemp:956.621993,
         quenchingTemp:53.942922,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580890020.000000,
         furnaceTemp:956.126420,
         quenchingTemp:55.668492,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580890620.000000,
         furnaceTemp:954.588190,
         quenchingTemp:54.776230,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580891220.000000,
         furnaceTemp:955.680373,
         quenchingTemp:54.732048,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580891820.000000,
         furnaceTemp:955.785240,
         quenchingTemp:54.565479,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580892420.000000,
         furnaceTemp:956.623133,
         quenchingTemp:56.480017,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580893020.000000,
         furnaceTemp:956.637922,
         quenchingTemp:56.727849,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580893620.000000,
         furnaceTemp:952.061188,
         quenchingTemp:54.324790,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580894220.000000,
         furnaceTemp:955.166894,
         quenchingTemp:56.694610,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580894820.000000,
         furnaceTemp:954.894427,
         quenchingTemp:54.198893,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580895420.000000,
         furnaceTemp:952.854483,
         quenchingTemp:53.556360,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580896020.000000,
         furnaceTemp:955.552787,
         quenchingTemp:54.914889,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580896620.000000,
         furnaceTemp:954.531400,
         quenchingTemp:53.419137,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580897220.000000,
         furnaceTemp:954.144761,
         quenchingTemp:53.600319,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580897820.000000,
         furnaceTemp:955.616005,
         quenchingTemp:53.597400,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580898420.000000,
         furnaceTemp:955.039068,
         quenchingTemp:55.539232,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580899020.000000,
         furnaceTemp:954.068943,
         quenchingTemp:55.684619,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580899620.000000,
         furnaceTemp:955.017565,
         quenchingTemp:53.905451,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580900220.000000,
         furnaceTemp:952.558892,
         quenchingTemp:53.554643,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580900820.000000,
         furnaceTemp:957.527881,
         quenchingTemp:55.515920,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580901420.000000,
         furnaceTemp:954.812213,
         quenchingTemp:55.134057,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580902020.000000,
         furnaceTemp:954.525658,
         quenchingTemp:56.240582,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580902620.000000,
         furnaceTemp:953.189531,
         quenchingTemp:55.731674,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580903220.000000,
         furnaceTemp:953.248774,
         quenchingTemp:54.357038,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580903820.000000,
         furnaceTemp:953.981015,
         quenchingTemp:56.864609,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580904420.000000,
         furnaceTemp:956.182049,
         quenchingTemp:56.261130,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580905020.000000,
         furnaceTemp:954.501066,
         quenchingTemp:54.316091,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580905620.000000,
         furnaceTemp:954.198102,
         quenchingTemp:54.589671,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580906220.000000,
         furnaceTemp:956.110494,
         quenchingTemp:54.916570,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580906820.000000,
         furnaceTemp:953.607243,
         quenchingTemp:54.346899,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580907420.000000,
         furnaceTemp:954.433001,
         quenchingTemp:55.136515,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580908020.000000,
         furnaceTemp:956.367987,
         quenchingTemp:55.010706,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580908620.000000,
         furnaceTemp:956.025063,
         quenchingTemp:55.266676,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580909220.000000,
         furnaceTemp:955.615086,
         quenchingTemp:54.852996,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580909820.000000,
         furnaceTemp:955.490800,
         quenchingTemp:55.890909,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580910420.000000,
         furnaceTemp:954.695065,
         quenchingTemp:53.638793,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580911020.000000,
         furnaceTemp:956.991754,
         quenchingTemp:53.992586,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580911620.000000,
         furnaceTemp:955.358705,
         quenchingTemp:53.474032,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580912220.000000,
         furnaceTemp:954.185122,
         quenchingTemp:56.005014,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580912820.000000,
         furnaceTemp:955.468185,
         quenchingTemp:52.941696,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580913420.000000,
         furnaceTemp:953.331426,
         quenchingTemp:55.001000,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580914020.000000,
         furnaceTemp:954.729472,
         quenchingTemp:57.074017,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580914620.000000,
         furnaceTemp:953.755553,
         quenchingTemp:55.007432,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580915220.000000,
         furnaceTemp:956.901537,
         quenchingTemp:55.901971,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580915820.000000,
         furnaceTemp:954.501606,
         quenchingTemp:53.922958,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580916420.000000,
         furnaceTemp:953.660262,
         quenchingTemp:55.875110,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580917020.000000,
         furnaceTemp:956.683923,
         quenchingTemp:54.814179,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580917620.000000,
         furnaceTemp:953.600133,
         quenchingTemp:53.755101,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580918220.000000,
         furnaceTemp:953.822082,
         quenchingTemp:55.298031,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580918820.000000,
         furnaceTemp:954.517585,
         quenchingTemp:53.713568,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580919420.000000,
         furnaceTemp:954.211595,
         quenchingTemp:52.900288,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580920020.000000,
         furnaceTemp:954.379992,
         quenchingTemp:56.473554,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580920620.000000,
         furnaceTemp:955.415538,
         quenchingTemp:55.497661,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580921220.000000,
         furnaceTemp:955.330390,
         quenchingTemp:53.829356,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580921820.000000,
         furnaceTemp:955.621272,
         quenchingTemp:55.796009,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580922420.000000,
         furnaceTemp:955.707586,
         quenchingTemp:54.213427,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580923020.000000,
         furnaceTemp:954.267031,
         quenchingTemp:51.834943,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580923620.000000,
         furnaceTemp:955.394891,
         quenchingTemp:54.892234,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580924220.000000,
         furnaceTemp:956.131348,
         quenchingTemp:55.980683,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580924820.000000,
         furnaceTemp:955.354893,
         quenchingTemp:54.186533,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580925420.000000,
         furnaceTemp:955.221417,
         quenchingTemp:56.610986,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580926020.000000,
         furnaceTemp:954.191282,
         quenchingTemp:56.634505,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580926620.000000,
         furnaceTemp:955.021163,
         quenchingTemp:57.248023,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580927220.000000,
         furnaceTemp:955.102944,
         quenchingTemp:54.929977,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580927820.000000,
         furnaceTemp:956.363547,
         quenchingTemp:53.865892,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580928420.000000,
         furnaceTemp:953.179309,
         quenchingTemp:54.833115,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580929020.000000,
         furnaceTemp:953.254054,
         quenchingTemp:56.685855,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580929620.000000,
         furnaceTemp:953.622855,
         quenchingTemp:55.645878,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580930220.000000,
         furnaceTemp:955.490070,
         quenchingTemp:53.446015,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580930820.000000,
         furnaceTemp:954.809598,
         quenchingTemp:52.468757,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580931420.000000,
         furnaceTemp:955.317757,
         quenchingTemp:57.381163,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580932020.000000,
         furnaceTemp:952.219298,
         quenchingTemp:56.199314,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580932620.000000,
         furnaceTemp:954.011992,
         quenchingTemp:56.529425,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580933220.000000,
         furnaceTemp:953.940400,
         quenchingTemp:53.262997,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580933820.000000,
         furnaceTemp:955.384897,
         quenchingTemp:55.441997,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580934420.000000,
         furnaceTemp:955.023044,
         quenchingTemp:53.365724,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580935020.000000,
         furnaceTemp:956.935611,
         quenchingTemp:55.429204,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580935620.000000,
         furnaceTemp:956.401544,
         quenchingTemp:55.508083,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580936220.000000,
         furnaceTemp:956.436360,
         quenchingTemp:54.882053,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580936820.000000,
         furnaceTemp:955.349630,
         quenchingTemp:55.546896,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580937420.000000,
         furnaceTemp:955.379535,
         quenchingTemp:56.240580,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580938020.000000,
         furnaceTemp:955.026443,
         quenchingTemp:53.711906,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580938620.000000,
         furnaceTemp:956.208341,
         quenchingTemp:53.891776,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580939220.000000,
         furnaceTemp:954.398490,
         quenchingTemp:55.929354,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580939820.000000,
         furnaceTemp:954.038857,
         quenchingTemp:55.314954,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580940420.000000,
         furnaceTemp:953.146273,
         quenchingTemp:54.887863,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580941020.000000,
         furnaceTemp:953.203209,
         quenchingTemp:54.815101,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580941620.000000,
         furnaceTemp:953.656453,
         quenchingTemp:53.654246,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580942220.000000,
         furnaceTemp:954.294941,
         quenchingTemp:54.748182,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580942820.000000,
         furnaceTemp:956.302624,
         quenchingTemp:55.196447,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580943420.000000,
         furnaceTemp:955.219491,
         quenchingTemp:56.345463,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580944020.000000,
         furnaceTemp:955.256099,
         quenchingTemp:54.555172,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580944620.000000,
         furnaceTemp:953.331130,
         quenchingTemp:54.106336,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580945220.000000,
         furnaceTemp:953.442230,
         quenchingTemp:54.670810,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580945820.000000,
         furnaceTemp:956.398360,
         quenchingTemp:54.977383,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580946420.000000,
         furnaceTemp:955.903556,
         quenchingTemp:55.808239,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580947020.000000,
         furnaceTemp:954.947225,
         quenchingTemp:54.969072,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580947620.000000,
         furnaceTemp:954.932973,
         quenchingTemp:56.013225,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580948220.000000,
         furnaceTemp:954.672548,
         quenchingTemp:55.718756,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580948820.000000,
         furnaceTemp:955.470840,
         quenchingTemp:56.217334,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580949420.000000,
         furnaceTemp:956.416169,
         quenchingTemp:57.539321,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580950020.000000,
         furnaceTemp:954.649786,
         quenchingTemp:55.808676,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580950620.000000,
         furnaceTemp:957.325735,
         quenchingTemp:56.248054,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580951220.000000,
         furnaceTemp:952.674206,
         quenchingTemp:53.910990,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580951820.000000,
         furnaceTemp:954.517173,
         quenchingTemp:55.986969,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580952420.000000,
         furnaceTemp:953.571650,
         quenchingTemp:54.306936,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580953020.000000,
         furnaceTemp:954.070916,
         quenchingTemp:55.866592,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580953620.000000,
         furnaceTemp:954.362354,
         quenchingTemp:55.171049,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580954220.000000,
         furnaceTemp:955.798860,
         quenchingTemp:55.390267,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580954820.000000,
         furnaceTemp:953.624465,
         quenchingTemp:53.637035,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580955420.000000,
         furnaceTemp:952.592065,
         quenchingTemp:54.370038,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580956020.000000,
         furnaceTemp:954.715377,
         quenchingTemp:57.179956,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580956620.000000,
         furnaceTemp:955.891915,
         quenchingTemp:55.699180,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580957220.000000,
         furnaceTemp:955.079499,
         quenchingTemp:54.690009,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580957820.000000,
         furnaceTemp:953.989654,
         quenchingTemp:54.142013,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580958420.000000,
         furnaceTemp:953.840057,
         quenchingTemp:54.301153,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580959020.000000,
         furnaceTemp:954.892807,
         quenchingTemp:55.243453,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580959620.000000,
         furnaceTemp:953.638315,
         quenchingTemp:57.523610,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580960220.000000,
         furnaceTemp:955.954729,
         quenchingTemp:56.720743,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580960820.000000,
         furnaceTemp:953.825012,
         quenchingTemp:55.361313,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580961420.000000,
         furnaceTemp:957.243176,
         quenchingTemp:53.669706,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580962020.000000,
         furnaceTemp:953.905684,
         quenchingTemp:54.396518,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580962620.000000,
         furnaceTemp:955.544995,
         quenchingTemp:56.410331,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580963220.000000,
         furnaceTemp:955.455668,
         quenchingTemp:55.361372,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580963820.000000,
         furnaceTemp:955.183935,
         quenchingTemp:55.666310,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580964420.000000,
         furnaceTemp:956.388439,
         quenchingTemp:53.673434,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580965020.000000,
         furnaceTemp:954.400001,
         quenchingTemp:54.398832,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580965620.000000,
         furnaceTemp:952.171172,
         quenchingTemp:56.493713,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580966220.000000,
         furnaceTemp:955.468955,
         quenchingTemp:54.956520,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580966820.000000,
         furnaceTemp:952.875692,
         quenchingTemp:54.150418,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580967420.000000,
         furnaceTemp:956.031116,
         quenchingTemp:54.887399,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580968020.000000,
         furnaceTemp:955.833773,
         quenchingTemp:54.598663,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580968620.000000,
         furnaceTemp:954.214320,
         quenchingTemp:54.440417,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580969220.000000,
         furnaceTemp:955.641156,
         quenchingTemp:54.713942,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580969820.000000,
         furnaceTemp:955.655061,
         quenchingTemp:54.397266,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580970420.000000,
         furnaceTemp:952.856040,
         quenchingTemp:54.851610,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580971020.000000,
         furnaceTemp:955.756767,
         quenchingTemp:52.755396,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580971620.000000,
         furnaceTemp:954.712725,
         quenchingTemp:54.015657,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580972220.000000,
         furnaceTemp:956.587906,
         quenchingTemp:54.941389,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580972820.000000,
         furnaceTemp:953.042873,
         quenchingTemp:52.345160,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580973420.000000,
         furnaceTemp:955.399474,
         quenchingTemp:56.333938,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580974020.000000,
         furnaceTemp:956.034266,
         quenchingTemp:55.699380,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580974620.000000,
         furnaceTemp:954.032017,
         quenchingTemp:57.410316,
         quenchingAgit:3,
         temperedTemp:0.000000,
      },
      {
         time:1580975220.000000,
         furnaceTemp:955.440017,
         quenchingTemp:54.425339,
         quenchingAgit:3,
         temperedTemp:600.000000,
      },
      {
         time:1580975820.000000,
         furnaceTemp:955.421028,
         quenchingTemp:55.662328,
         quenchingAgit:3,
         temperedTemp:600.000000,
      },
      {
         time:1580976000.000000,
         furnaceTemp:954.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:600.000000,
      },
      {
         time:1580976420.000000,
         furnaceTemp:952.761260,
         quenchingTemp:54.588574,
         quenchingAgit:3,
         temperedTemp:608.945495,
      },
      {
         time:1580977020.000000,
         furnaceTemp:955.050293,
         quenchingTemp:56.712294,
         quenchingAgit:3,
         temperedTemp:607.186863,
      },
      {
         time:1580977620.000000,
         furnaceTemp:955.319146,
         quenchingTemp:54.344369,
         quenchingAgit:3,
         temperedTemp:609.436427,
      },
      {
         time:1580978220.000000,
         furnaceTemp:954.475420,
         quenchingTemp:56.090196,
         quenchingAgit:3,
         temperedTemp:608.675262,
      },
      {
         time:1580978820.000000,
         furnaceTemp:955.166325,
         quenchingTemp:53.783039,
         quenchingAgit:3,
         temperedTemp:606.651682,
      },
      {
         time:1580979420.000000,
         furnaceTemp:957.313499,
         quenchingTemp:55.309891,
         quenchingAgit:3,
         temperedTemp:609.191257,
      },
      {
         time:1580980020.000000,
         furnaceTemp:955.912619,
         quenchingTemp:52.874402,
         quenchingAgit:3,
         temperedTemp:609.176592,
      },
      {
         time:1580980620.000000,
         furnaceTemp:954.827328,
         quenchingTemp:55.922537,
         quenchingAgit:3,
         temperedTemp:608.389394,
      },
      {
         time:1580981220.000000,
         furnaceTemp:954.310911,
         quenchingTemp:52.879964,
         quenchingAgit:3,
         temperedTemp:608.544529,
      },
      {
         time:1580981820.000000,
         furnaceTemp:953.056874,
         quenchingTemp:54.276930,
         quenchingAgit:3,
         temperedTemp:610.566511,
      },
      {
         time:1580982420.000000,
         furnaceTemp:953.726306,
         quenchingTemp:54.774739,
         quenchingAgit:3,
         temperedTemp:609.929503,
      },
      {
         time:1580983020.000000,
         furnaceTemp:955.456511,
         quenchingTemp:53.659964,
         quenchingAgit:3,
         temperedTemp:610.379040,
      },
      {
         time:1580983620.000000,
         furnaceTemp:954.409671,
         quenchingTemp:56.265532,
         quenchingAgit:3,
         temperedTemp:610.811034,
      },
      {
         time:1580984220.000000,
         furnaceTemp:954.940962,
         quenchingTemp:53.169730,
         quenchingAgit:3,
         temperedTemp:609.557418,
      },
      {
         time:1580984820.000000,
         furnaceTemp:956.551617,
         quenchingTemp:53.895329,
         quenchingAgit:3,
         temperedTemp:611.306728,
      },
      {
         time:1580985420.000000,
         furnaceTemp:956.381689,
         quenchingTemp:53.514479,
         quenchingAgit:3,
         temperedTemp:610.613650,
      },
      {
         time:1580986020.000000,
         furnaceTemp:953.415821,
         quenchingTemp:54.366291,
         quenchingAgit:3,
         temperedTemp:608.729902,
      },
      {
         time:1580986620.000000,
         furnaceTemp:955.042927,
         quenchingTemp:55.978383,
         quenchingAgit:3,
         temperedTemp:612.389113,
      },
      {
         time:1580987220.000000,
         furnaceTemp:954.585713,
         quenchingTemp:54.269299,
         quenchingAgit:3,
         temperedTemp:607.593397,
      },
      {
         time:1580987820.000000,
         furnaceTemp:954.623985,
         quenchingTemp:55.707528,
         quenchingAgit:3,
         temperedTemp:610.627234,
      },
      {
         time:1580988420.000000,
         furnaceTemp:954.205032,
         quenchingTemp:54.691464,
         quenchingAgit:3,
         temperedTemp:609.100531,
      },
      {
         time:1580989020.000000,
         furnaceTemp:956.011414,
         quenchingTemp:55.161485,
         quenchingAgit:3,
         temperedTemp:608.516555,
      },
      {
         time:1580989620.000000,
         furnaceTemp:955.420052,
         quenchingTemp:56.553617,
         quenchingAgit:3,
         temperedTemp:611.975374,
      },
      {
         time:1580990220.000000,
         furnaceTemp:954.471682,
         quenchingTemp:53.782322,
         quenchingAgit:3,
         temperedTemp:608.268332,
      },
      {
         time:1580990820.000000,
         furnaceTemp:956.667039,
         quenchingTemp:54.050446,
         quenchingAgit:3,
         temperedTemp:610.390823,
      },
      {
         time:1580991420.000000,
         furnaceTemp:954.502780,
         quenchingTemp:54.493043,
         quenchingAgit:3,
         temperedTemp:611.189063,
      },
      {
         time:1580992020.000000,
         furnaceTemp:957.051985,
         quenchingTemp:57.253959,
         quenchingAgit:3,
         temperedTemp:610.437430,
      },
      {
         time:1580992620.000000,
         furnaceTemp:954.913764,
         quenchingTemp:55.242018,
         quenchingAgit:3,
         temperedTemp:611.145482,
      },
      {
         time:1580993220.000000,
         furnaceTemp:956.779669,
         quenchingTemp:55.215710,
         quenchingAgit:3,
         temperedTemp:610.030466,
      },
      {
         time:1580993820.000000,
         furnaceTemp:955.769298,
         quenchingTemp:56.433199,
         quenchingAgit:3,
         temperedTemp:610.149708,
      },
      {
         time:1580994420.000000,
         furnaceTemp:955.823371,
         quenchingTemp:53.997424,
         quenchingAgit:3,
         temperedTemp:608.962544,
      },
      {
         time:1580995020.000000,
         furnaceTemp:955.262214,
         quenchingTemp:55.538251,
         quenchingAgit:3,
         temperedTemp:608.846421,
      },
      {
         time:1580995620.000000,
         furnaceTemp:955.048945,
         quenchingTemp:55.414738,
         quenchingAgit:3,
         temperedTemp:610.257144,
      },
      {
         time:1580996220.000000,
         furnaceTemp:955.068665,
         quenchingTemp:54.743539,
         quenchingAgit:3,
         temperedTemp:611.596919,
      },
      {
         time:1580996820.000000,
         furnaceTemp:955.621317,
         quenchingTemp:57.698793,
         quenchingAgit:3,
         temperedTemp:609.492653,
      },
      {
         time:1580997420.000000,
         furnaceTemp:953.877068,
         quenchingTemp:53.520677,
         quenchingAgit:3,
         temperedTemp:610.635026,
      },
      {
         time:1580998020.000000,
         furnaceTemp:955.645436,
         quenchingTemp:54.025644,
         quenchingAgit:3,
         temperedTemp:608.704473,
      },
      {
         time:1580998620.000000,
         furnaceTemp:955.102625,
         quenchingTemp:56.318684,
         quenchingAgit:3,
         temperedTemp:609.724071,
      },
      {
         time:1580999220.000000,
         furnaceTemp:955.810483,
         quenchingTemp:55.807833,
         quenchingAgit:2,
         temperedTemp:608.838318,
      },
      {
         time:1580999820.000000,
         furnaceTemp:953.914533,
         quenchingTemp:55.858745,
         quenchingAgit:3,
         temperedTemp:611.559646,
      },
      {
         time:1581000420.000000,
         furnaceTemp:954.738203,
         quenchingTemp:54.302400,
         quenchingAgit:3,
         temperedTemp:609.873048,
      },
      {
         time:1581001020.000000,
         furnaceTemp:954.564050,
         quenchingTemp:56.081322,
         quenchingAgit:3,
         temperedTemp:609.893939,
      },
      {
         time:1581001620.000000,
         furnaceTemp:954.353816,
         quenchingTemp:54.119646,
         quenchingAgit:3,
         temperedTemp:609.343323,
      },
      {
         time:1581002220.000000,
         furnaceTemp:955.784847,
         quenchingTemp:55.553794,
         quenchingAgit:3,
         temperedTemp:609.806955,
      },
      {
         time:1581002820.000000,
         furnaceTemp:955.682838,
         quenchingTemp:54.474053,
         quenchingAgit:3,
         temperedTemp:611.528997,
      },
      {
         time:1581003420.000000,
         furnaceTemp:952.895377,
         quenchingTemp:55.164744,
         quenchingAgit:3,
         temperedTemp:609.016651,
      },
      {
         time:1581004020.000000,
         furnaceTemp:953.347974,
         quenchingTemp:51.751675,
         quenchingAgit:3,
         temperedTemp:611.636741,
      },
      {
         time:1581004620.000000,
         furnaceTemp:955.539203,
         quenchingTemp:55.450231,
         quenchingAgit:3,
         temperedTemp:609.792323,
      },
      {
         time:1581005220.000000,
         furnaceTemp:955.281629,
         quenchingTemp:54.183938,
         quenchingAgit:3,
         temperedTemp:611.349200,
      },
      {
         time:1581005820.000000,
         furnaceTemp:953.275898,
         quenchingTemp:55.176688,
         quenchingAgit:3,
         temperedTemp:612.077734,
      },
      {
         time:1581006420.000000,
         furnaceTemp:955.103924,
         quenchingTemp:55.029851,
         quenchingAgit:3,
         temperedTemp:610.991187,
      },
      {
         time:1581007020.000000,
         furnaceTemp:953.778295,
         quenchingTemp:54.756419,
         quenchingAgit:3,
         temperedTemp:610.546955,
      },
      {
         time:1581007620.000000,
         furnaceTemp:953.083973,
         quenchingTemp:54.385382,
         quenchingAgit:3,
         temperedTemp:610.881265,
      },
      {
         time:1581008220.000000,
         furnaceTemp:953.041741,
         quenchingTemp:56.106562,
         quenchingAgit:3,
         temperedTemp:609.532924,
      },
      {
         time:1581008820.000000,
         furnaceTemp:955.362470,
         quenchingTemp:55.392930,
         quenchingAgit:3,
         temperedTemp:609.379301,
      },
      {
         time:1581009420.000000,
         furnaceTemp:954.807865,
         quenchingTemp:55.671777,
         quenchingAgit:3,
         temperedTemp:608.153233,
      },
      {
         time:1581010020.000000,
         furnaceTemp:955.794940,
         quenchingTemp:53.656647,
         quenchingAgit:3,
         temperedTemp:611.720761,
      },
      {
         time:1581010620.000000,
         furnaceTemp:955.063182,
         quenchingTemp:55.454715,
         quenchingAgit:3,
         temperedTemp:610.925960,
      },
      {
         time:1581011220.000000,
         furnaceTemp:953.658289,
         quenchingTemp:55.221099,
         quenchingAgit:3,
         temperedTemp:608.506872,
      },
      {
         time:1581011820.000000,
         furnaceTemp:954.464135,
         quenchingTemp:54.801370,
         quenchingAgit:3,
         temperedTemp:609.504306,
      },
      {
         time:1581012420.000000,
         furnaceTemp:955.156068,
         quenchingTemp:55.953507,
         quenchingAgit:3,
         temperedTemp:610.214296,
      },
      {
         time:1581013020.000000,
         furnaceTemp:953.284770,
         quenchingTemp:56.258287,
         quenchingAgit:3,
         temperedTemp:610.015165,
      },
      {
         time:1581013620.000000,
         furnaceTemp:955.689634,
         quenchingTemp:55.038258,
         quenchingAgit:3,
         temperedTemp:610.677049,
      },
      {
         time:1581014220.000000,
         furnaceTemp:954.884622,
         quenchingTemp:55.164236,
         quenchingAgit:3,
         temperedTemp:611.520160,
      },
      {
         time:1581014820.000000,
         furnaceTemp:954.844561,
         quenchingTemp:55.630736,
         quenchingAgit:3,
         temperedTemp:610.720865,
      },
      {
         time:1581015420.000000,
         furnaceTemp:955.969093,
         quenchingTemp:57.093299,
         quenchingAgit:3,
         temperedTemp:609.661410,
      },
      {
         time:1581016020.000000,
         furnaceTemp:954.223204,
         quenchingTemp:57.273540,
         quenchingAgit:3,
         temperedTemp:610.568355,
      },
      {
         time:1581016620.000000,
         furnaceTemp:954.212792,
         quenchingTemp:56.876293,
         quenchingAgit:3,
         temperedTemp:610.951643,
      },
      {
         time:1581017220.000000,
         furnaceTemp:954.814059,
         quenchingTemp:56.007015,
         quenchingAgit:3,
         temperedTemp:610.092293,
      },
      {
         time:1581017820.000000,
         furnaceTemp:953.949600,
         quenchingTemp:54.283308,
         quenchingAgit:3,
         temperedTemp:608.790525,
      },
      {
         time:1581018420.000000,
         furnaceTemp:956.040466,
         quenchingTemp:54.587035,
         quenchingAgit:3,
         temperedTemp:607.734716,
      },
      {
         time:1581019020.000000,
         furnaceTemp:955.332862,
         quenchingTemp:54.341302,
         quenchingAgit:3,
         temperedTemp:610.198769,
      },
      {
         time:1581019620.000000,
         furnaceTemp:953.465078,
         quenchingTemp:57.196350,
         quenchingAgit:3,
         temperedTemp:610.711782,
      },
      {
         time:1581020220.000000,
         furnaceTemp:956.421140,
         quenchingTemp:55.675693,
         quenchingAgit:3,
         temperedTemp:611.202971,
      },
      {
         time:1581020820.000000,
         furnaceTemp:955.566178,
         quenchingTemp:54.862400,
         quenchingAgit:3,
         temperedTemp:609.813618,
      },
      {
         time:1581021420.000000,
         furnaceTemp:953.765131,
         quenchingTemp:55.813068,
         quenchingAgit:3,
         temperedTemp:610.012044,
      },
      {
         time:1581022020.000000,
         furnaceTemp:955.725480,
         quenchingTemp:55.011634,
         quenchingAgit:3,
         temperedTemp:607.506095,
      },
      {
         time:1581022620.000000,
         furnaceTemp:956.076512,
         quenchingTemp:55.970634,
         quenchingAgit:3,
         temperedTemp:608.897384,
      },
      {
         time:1581023220.000000,
         furnaceTemp:953.762984,
         quenchingTemp:54.301192,
         quenchingAgit:3,
         temperedTemp:609.784775,
      },
      {
         time:1581023820.000000,
         furnaceTemp:954.400789,
         quenchingTemp:55.559089,
         quenchingAgit:3,
         temperedTemp:610.774310,
      },
      {
         time:1581024420.000000,
         furnaceTemp:953.048595,
         quenchingTemp:56.454181,
         quenchingAgit:3,
         temperedTemp:610.738444,
      },
      {
         time:1581025020.000000,
         furnaceTemp:956.486183,
         quenchingTemp:55.476243,
         quenchingAgit:3,
         temperedTemp:610.019484,
      },
      {
         time:1581025620.000000,
         furnaceTemp:954.570973,
         quenchingTemp:54.511043,
         quenchingAgit:3,
         temperedTemp:610.690774,
      },
      {
         time:1581026220.000000,
         furnaceTemp:954.062070,
         quenchingTemp:56.962582,
         quenchingAgit:3,
         temperedTemp:609.836957,
      },
      {
         time:1581026820.000000,
         furnaceTemp:954.632570,
         quenchingTemp:54.045386,
         quenchingAgit:3,
         temperedTemp:609.344502,
      },
      {
         time:1581027420.000000,
         furnaceTemp:954.358620,
         quenchingTemp:57.020325,
         quenchingAgit:3,
         temperedTemp:610.626308,
      },
      {
         time:1581028020.000000,
         furnaceTemp:953.170852,
         quenchingTemp:55.480165,
         quenchingAgit:3,
         temperedTemp:612.320792,
      },
      {
         time:1581028620.000000,
         furnaceTemp:955.080896,
         quenchingTemp:54.330108,
         quenchingAgit:3,
         temperedTemp:611.381249,
      },
      {
         time:1581029220.000000,
         furnaceTemp:954.160293,
         quenchingTemp:54.451115,
         quenchingAgit:3,
         temperedTemp:611.372220,
      },
      {
         time:1581029820.000000,
         furnaceTemp:954.680449,
         quenchingTemp:55.105066,
         quenchingAgit:3,
         temperedTemp:607.915781,
      },
      {
         time:1581030420.000000,
         furnaceTemp:954.132803,
         quenchingTemp:55.540499,
         quenchingAgit:3,
         temperedTemp:610.024235,
      },
      {
         time:1581031020.000000,
         furnaceTemp:954.895810,
         quenchingTemp:53.310717,
         quenchingAgit:3,
         temperedTemp:609.947189,
      },
      {
         time:1581031620.000000,
         furnaceTemp:954.780169,
         quenchingTemp:54.877225,
         quenchingAgit:3,
         temperedTemp:609.994623,
      },
      {
         time:1581032220.000000,
         furnaceTemp:953.314583,
         quenchingTemp:54.497694,
         quenchingAgit:3,
         temperedTemp:610.580005,
      },
      {
         time:1581032820.000000,
         furnaceTemp:953.446272,
         quenchingTemp:55.004258,
         quenchingAgit:3,
         temperedTemp:609.395149,
      },
      {
         time:1581033420.000000,
         furnaceTemp:954.043520,
         quenchingTemp:55.654426,
         quenchingAgit:3,
         temperedTemp:609.216333,
      },
      {
         time:1581034020.000000,
         furnaceTemp:953.146514,
         quenchingTemp:52.435364,
         quenchingAgit:3,
         temperedTemp:611.253762,
      },
      {
         time:1581034620.000000,
         furnaceTemp:955.047853,
         quenchingTemp:54.050926,
         quenchingAgit:3,
         temperedTemp:611.830471,
      },
      {
         time:1581035220.000000,
         furnaceTemp:953.829327,
         quenchingTemp:52.769167,
         quenchingAgit:3,
         temperedTemp:608.648413,
      },
      {
         time:1581035820.000000,
         furnaceTemp:954.782500,
         quenchingTemp:56.523994,
         quenchingAgit:3,
         temperedTemp:610.952507,
      },
      {
         time:1581036420.000000,
         furnaceTemp:956.368826,
         quenchingTemp:55.267622,
         quenchingAgit:3,
         temperedTemp:609.201963,
      },
      {
         time:1581037020.000000,
         furnaceTemp:955.087158,
         quenchingTemp:53.914579,
         quenchingAgit:3,
         temperedTemp:609.664879,
      },
      {
         time:1581037620.000000,
         furnaceTemp:954.177146,
         quenchingTemp:55.119107,
         quenchingAgit:3,
         temperedTemp:610.687379,
      },
      {
         time:1581038220.000000,
         furnaceTemp:953.459549,
         quenchingTemp:52.750399,
         quenchingAgit:3,
         temperedTemp:610.249322,
      },
      {
         time:1581038820.000000,
         furnaceTemp:953.961615,
         quenchingTemp:56.349937,
         quenchingAgit:3,
         temperedTemp:610.545110,
      },
      {
         time:1581039420.000000,
         furnaceTemp:957.028301,
         quenchingTemp:55.894231,
         quenchingAgit:3,
         temperedTemp:609.056228,
      },
      {
         time:1581040020.000000,
         furnaceTemp:955.865908,
         quenchingTemp:52.932631,
         quenchingAgit:3,
         temperedTemp:609.280356,
      },
      {
         time:1581040620.000000,
         furnaceTemp:956.141264,
         quenchingTemp:54.514820,
         quenchingAgit:3,
         temperedTemp:609.057544,
      },
      {
         time:1581041220.000000,
         furnaceTemp:953.128088,
         quenchingTemp:54.542589,
         quenchingAgit:3,
         temperedTemp:608.361259,
      },
      {
         time:1581041820.000000,
         furnaceTemp:954.402617,
         quenchingTemp:55.155353,
         quenchingAgit:3,
         temperedTemp:610.087001,
      },
      {
         time:1581042420.000000,
         furnaceTemp:955.611890,
         quenchingTemp:55.432232,
         quenchingAgit:3,
         temperedTemp:607.837373,
      },
      {
         time:1581043020.000000,
         furnaceTemp:954.372998,
         quenchingTemp:56.469866,
         quenchingAgit:3,
         temperedTemp:609.002770,
      },
      {
         time:1581043620.000000,
         furnaceTemp:952.639966,
         quenchingTemp:56.644390,
         quenchingAgit:3,
         temperedTemp:610.617615,
      },
      {
         time:1581044220.000000,
         furnaceTemp:957.924376,
         quenchingTemp:54.813786,
         quenchingAgit:3,
         temperedTemp:610.063465,
      },
      {
         time:1581044820.000000,
         furnaceTemp:955.654378,
         quenchingTemp:55.941686,
         quenchingAgit:3,
         temperedTemp:610.951907,
      },
      {
         time:1581045420.000000,
         furnaceTemp:954.731819,
         quenchingTemp:53.402242,
         quenchingAgit:3,
         temperedTemp:611.825645,
      },
      {
         time:1581046020.000000,
         furnaceTemp:954.212557,
         quenchingTemp:52.633016,
         quenchingAgit:3,
         temperedTemp:608.323778,
      },
      {
         time:1581046620.000000,
         furnaceTemp:955.929494,
         quenchingTemp:53.555759,
         quenchingAgit:3,
         temperedTemp:609.898926,
      },
      {
         time:1581047220.000000,
         furnaceTemp:955.452866,
         quenchingTemp:57.692505,
         quenchingAgit:3,
         temperedTemp:610.781611,
      },
      {
         time:1581047820.000000,
         furnaceTemp:955.916578,
         quenchingTemp:53.663602,
         quenchingAgit:3,
         temperedTemp:610.256038,
      },
      {
         time:1581048420.000000,
         furnaceTemp:954.570467,
         quenchingTemp:54.466267,
         quenchingAgit:3,
         temperedTemp:609.224758,
      },
      {
         time:1581049020.000000,
         furnaceTemp:953.129206,
         quenchingTemp:54.983699,
         quenchingAgit:3,
         temperedTemp:610.691354,
      },
      {
         time:1581049620.000000,
         furnaceTemp:956.040627,
         quenchingTemp:56.899981,
         quenchingAgit:3,
         temperedTemp:608.945236,
      },
      {
         time:1581050220.000000,
         furnaceTemp:953.334707,
         quenchingTemp:56.075093,
         quenchingAgit:3,
         temperedTemp:609.574693,
      },
      {
         time:1581050820.000000,
         furnaceTemp:955.938376,
         quenchingTemp:55.589898,
         quenchingAgit:3,
         temperedTemp:611.365674,
      },
      {
         time:1581051420.000000,
         furnaceTemp:955.696530,
         quenchingTemp:54.156934,
         quenchingAgit:3,
         temperedTemp:609.913134,
      },
      {
         time:1581052020.000000,
         furnaceTemp:954.548785,
         quenchingTemp:55.828027,
         quenchingAgit:3,
         temperedTemp:608.272330,
      },
      {
         time:1581052620.000000,
         furnaceTemp:952.373196,
         quenchingTemp:55.128918,
         quenchingAgit:3,
         temperedTemp:607.102087,
      },
      {
         time:1581053220.000000,
         furnaceTemp:955.080923,
         quenchingTemp:55.741585,
         quenchingAgit:3,
         temperedTemp:611.062835,
      },
      {
         time:1581053820.000000,
         furnaceTemp:952.715531,
         quenchingTemp:55.793231,
         quenchingAgit:3,
         temperedTemp:609.423965,
      },
      {
         time:1581054420.000000,
         furnaceTemp:954.783557,
         quenchingTemp:55.906141,
         quenchingAgit:3,
         temperedTemp:609.178624,
      },
      {
         time:1581055020.000000,
         furnaceTemp:954.475498,
         quenchingTemp:56.375337,
         quenchingAgit:3,
         temperedTemp:608.937953,
      },
      {
         time:1581055620.000000,
         furnaceTemp:956.177662,
         quenchingTemp:53.334094,
         quenchingAgit:3,
         temperedTemp:609.428057,
      },
      {
         time:1581056220.000000,
         furnaceTemp:953.907290,
         quenchingTemp:52.849531,
         quenchingAgit:3,
         temperedTemp:608.649637,
      },
      {
         time:1581056820.000000,
         furnaceTemp:954.729759,
         quenchingTemp:53.039480,
         quenchingAgit:3,
         temperedTemp:607.690122,
      },
      {
         time:1581057420.000000,
         furnaceTemp:955.727472,
         quenchingTemp:53.301401,
         quenchingAgit:3,
         temperedTemp:608.087144,
      },
      {
         time:1581058020.000000,
         furnaceTemp:955.365210,
         quenchingTemp:56.007396,
         quenchingAgit:3,
         temperedTemp:608.421668,
      },
      {
         time:1581058620.000000,
         furnaceTemp:955.729463,
         quenchingTemp:55.517394,
         quenchingAgit:3,
         temperedTemp:609.135916,
      },
      {
         time:1581059220.000000,
         furnaceTemp:956.591142,
         quenchingTemp:53.494675,
         quenchingAgit:3,
         temperedTemp:611.522346,
      },
      {
         time:1581059820.000000,
         furnaceTemp:956.471348,
         quenchingTemp:56.433049,
         quenchingAgit:3,
         temperedTemp:610.959019,
      },
      {
         time:1581060420.000000,
         furnaceTemp:956.216882,
         quenchingTemp:53.772257,
         quenchingAgit:3,
         temperedTemp:609.415280,
      },
      {
         time:1581061020.000000,
         furnaceTemp:954.734461,
         quenchingTemp:55.072346,
         quenchingAgit:3,
         temperedTemp:611.306898,
      },
      {
         time:1581061620.000000,
         furnaceTemp:956.542826,
         quenchingTemp:54.674462,
         quenchingAgit:3,
         temperedTemp:609.685407,
      },
      {
         time:1581062220.000000,
         furnaceTemp:954.378089,
         quenchingTemp:55.763034,
         quenchingAgit:3,
         temperedTemp:610.983329,
      },
      {
         time:1581062820.000000,
         furnaceTemp:953.350501,
         quenchingTemp:54.406003,
         quenchingAgit:3,
         temperedTemp:611.747125,
      },
      {
         time:1581063420.000000,
         furnaceTemp:955.610303,
         quenchingTemp:54.551452,
         quenchingAgit:3,
         temperedTemp:612.068663,
      },
      {
         time:1581064020.000000,
         furnaceTemp:955.826067,
         quenchingTemp:53.825911,
         quenchingAgit:3,
         temperedTemp:609.468694,
      },
      {
         time:1581064620.000000,
         furnaceTemp:954.501986,
         quenchingTemp:54.622587,
         quenchingAgit:3,
         temperedTemp:609.508991,
      },
      {
         time:1581065220.000000,
         furnaceTemp:953.160921,
         quenchingTemp:55.593634,
         quenchingAgit:3,
         temperedTemp:610.151633,
      },
      {
         time:1581065820.000000,
         furnaceTemp:955.325195,
         quenchingTemp:56.003389,
         quenchingAgit:3,
         temperedTemp:609.302348,
      },
      {
         time:1581066420.000000,
         furnaceTemp:953.387836,
         quenchingTemp:54.471065,
         quenchingAgit:3,
         temperedTemp:610.100476,
      },
      {
         time:1581067020.000000,
         furnaceTemp:954.060161,
         quenchingTemp:56.433657,
         quenchingAgit:3,
         temperedTemp:609.579515,
      },
      {
         time:1581067620.000000,
         furnaceTemp:954.251416,
         quenchingTemp:55.141001,
         quenchingAgit:3,
         temperedTemp:609.608094,
      },
      {
         time:1581068220.000000,
         furnaceTemp:955.875484,
         quenchingTemp:53.423390,
         quenchingAgit:3,
         temperedTemp:609.832850,
      },
      {
         time:1581068820.000000,
         furnaceTemp:955.463252,
         quenchingTemp:55.531847,
         quenchingAgit:3,
         temperedTemp:611.078818,
      },
      {
         time:1581069420.000000,
         furnaceTemp:956.962035,
         quenchingTemp:54.290406,
         quenchingAgit:3,
         temperedTemp:610.504540,
      },
      {
         time:1581070020.000000,
         furnaceTemp:952.607961,
         quenchingTemp:54.437313,
         quenchingAgit:3,
         temperedTemp:610.670492,
      },
      {
         time:1581070620.000000,
         furnaceTemp:954.998601,
         quenchingTemp:56.035089,
         quenchingAgit:3,
         temperedTemp:608.841329,
      },
      {
         time:1581071220.000000,
         furnaceTemp:954.157239,
         quenchingTemp:53.791117,
         quenchingAgit:3,
         temperedTemp:611.336259,
      },
      {
         time:1581071820.000000,
         furnaceTemp:956.128569,
         quenchingTemp:55.086799,
         quenchingAgit:3,
         temperedTemp:608.112240,
      },
      {
         time:1581072420.000000,
         furnaceTemp:954.369010,
         quenchingTemp:55.379876,
         quenchingAgit:3,
         temperedTemp:609.219199,
      },
      {
         time:1581073020.000000,
         furnaceTemp:952.926866,
         quenchingTemp:55.430065,
         quenchingAgit:3,
         temperedTemp:609.115526,
      },
      {
         time:1581073620.000000,
         furnaceTemp:955.660172,
         quenchingTemp:54.251345,
         quenchingAgit:3,
         temperedTemp:609.428038,
      },
      {
         time:1581074220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:54.854094,
         quenchingAgit:3,
         temperedTemp:609.637586,
      },
      {
         time:1581074820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:54.893358,
         quenchingAgit:3,
         temperedTemp:610.095394,
      },
      {
         time:1581075420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:55.891622,
         quenchingAgit:3,
         temperedTemp:609.581082,
      },
      {
         time:1581076020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:54.370214,
         quenchingAgit:3,
         temperedTemp:609.288814,
      },
      {
         time:1581076620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:55.190840,
         quenchingAgit:3,
         temperedTemp:610.232133,
      },
      {
         time:1581077220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:54.268999,
         quenchingAgit:3,
         temperedTemp:610.664126,
      },
      {
         time:1581077820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:55.117798,
         quenchingAgit:3,
         temperedTemp:609.375832,
      },
      {
         time:1581078420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:56.726313,
         quenchingAgit:3,
         temperedTemp:610.434610,
      },
      {
         time:1581079020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:56.039108,
         quenchingAgit:3,
         temperedTemp:610.711830,
      },
      {
         time:1581079620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:54.807889,
         quenchingAgit:3,
         temperedTemp:609.968531,
      },
      {
         time:1581080220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:53.263463,
         quenchingAgit:3,
         temperedTemp:609.700461,
      },
      {
         time:1581080820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:55.582728,
         quenchingAgit:3,
         temperedTemp:609.715390,
      },
      {
         time:1581081420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:54.847372,
         quenchingAgit:3,
         temperedTemp:608.805326,
      },
      {
         time:1581082020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:51.919922,
         quenchingAgit:3,
         temperedTemp:611.126400,
      },
      {
         time:1581082620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:56.254792,
         quenchingAgit:3,
         temperedTemp:610.057255,
      },
      {
         time:1581083220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:55.667425,
         quenchingAgit:3,
         temperedTemp:610.097963,
      },
      {
         time:1581083820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:53.932698,
         quenchingAgit:3,
         temperedTemp:607.834386,
      },
      {
         time:1581084420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:54.766619,
         quenchingAgit:3,
         temperedTemp:611.061301,
      },
      {
         time:1581085020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.733573,
      },
      {
         time:1581085620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.299945,
      },
      {
         time:1581086220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.861084,
      },
      {
         time:1581086820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.815996,
      },
      {
         time:1581087420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.530538,
      },
      {
         time:1581088020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.596402,
      },
      {
         time:1581088620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.341369,
      },
      {
         time:1581089220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.029565,
      },
      {
         time:1581089820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.718289,
      },
      {
         time:1581090420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.058317,
      },
      {
         time:1581091020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.394275,
      },
      {
         time:1581091620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.067706,
      },
      {
         time:1581092220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.543250,
      },
      {
         time:1581092820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.263614,
      },
      {
         time:1581093420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.890257,
      },
      {
         time:1581094020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.559730,
      },
      {
         time:1581094620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:613.547319,
      },
      {
         time:1581095220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.529135,
      },
      {
         time:1581095820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.137872,
      },
      {
         time:1581096420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.309086,
      },
      {
         time:1581097020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.976111,
      },
      {
         time:1581097620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.357927,
      },
      {
         time:1581098220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.689612,
      },
      {
         time:1581098820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.396825,
      },
      {
         time:1581099420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.466727,
      },
      {
         time:1581100020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.912624,
      },
      {
         time:1581100620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.154034,
      },
      {
         time:1581101220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.459768,
      },
      {
         time:1581101820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.454794,
      },
      {
         time:1581102420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.770698,
      },
      {
         time:1581103020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.958619,
      },
      {
         time:1581103620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.268721,
      },
      {
         time:1581104220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.003918,
      },
      {
         time:1581104820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.853585,
      },
      {
         time:1581105420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.791055,
      },
      {
         time:1581106020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.854516,
      },
      {
         time:1581106620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.109111,
      },
      {
         time:1581107220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.219967,
      },
      {
         time:1581107820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.776694,
      },
      {
         time:1581108420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.161254,
      },
      {
         time:1581109020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.598540,
      },
      {
         time:1581109620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.613237,
      },
      {
         time:1581110220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.120655,
      },
      {
         time:1581110820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.450392,
      },
      {
         time:1581111420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.944563,
      },
      {
         time:1581112020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.444815,
      },
      {
         time:1581112620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.271912,
      },
      {
         time:1581113220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.544411,
      },
      {
         time:1581113820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.788647,
      },
      {
         time:1581114420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.408808,
      },
      {
         time:1581115020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.268420,
      },
      {
         time:1581115620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.829744,
      },
      {
         time:1581116220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.142830,
      },
      {
         time:1581116820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.912945,
      },
      {
         time:1581117420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.511010,
      },
      {
         time:1581118020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.235389,
      },
      {
         time:1581118620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.415492,
      },
      {
         time:1581119220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.767292,
      },
      {
         time:1581119820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.813933,
      },
      {
         time:1581120420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.229482,
      },
      {
         time:1581121020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.945555,
      },
      {
         time:1581121620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.412442,
      },
      {
         time:1581122220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.706758,
      },
      {
         time:1581122820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.341511,
      },
      {
         time:1581123420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.724736,
      },
      {
         time:1581124020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.859576,
      },
      {
         time:1581124620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.502722,
      },
      {
         time:1581125220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.949561,
      },
      {
         time:1581125820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.269872,
      },
      {
         time:1581126420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.923456,
      },
      {
         time:1581127020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.888212,
      },
      {
         time:1581127620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.041110,
      },
      {
         time:1581128220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.442360,
      },
      {
         time:1581128820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.476557,
      },
      {
         time:1581129420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.609334,
      },
      {
         time:1581130020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.239498,
      },
      {
         time:1581130620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.155902,
      },
      {
         time:1581131220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.814632,
      },
      {
         time:1581131820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.179905,
      },
      {
         time:1581132420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.732546,
      },
      {
         time:1581133020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.439873,
      },
      {
         time:1581133620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.823763,
      },
      {
         time:1581134220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.948822,
      },
      {
         time:1581134820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.414466,
      },
      {
         time:1581135420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.085971,
      },
      {
         time:1581136020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.759064,
      },
      {
         time:1581136620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.359231,
      },
      {
         time:1581137220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.221127,
      },
      {
         time:1581137820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.359781,
      },
      {
         time:1581138420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.856752,
      },
      {
         time:1581139020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.063579,
      },
      {
         time:1581139620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.264100,
      },
      {
         time:1581140220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.066538,
      },
      {
         time:1581140820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.833732,
      },
      {
         time:1581141420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.687104,
      },
      {
         time:1581142020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.589576,
      },
      {
         time:1581142620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.294468,
      },
      {
         time:1581143220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.022580,
      },
      {
         time:1581143820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.252465,
      },
      {
         time:1581144420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.087770,
      },
      {
         time:1581145020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.477825,
      },
      {
         time:1581145620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.140414,
      },
      {
         time:1581146220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.139649,
      },
      {
         time:1581146820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.148456,
      },
      {
         time:1581147420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.212822,
      },
      {
         time:1581148020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.086391,
      },
      {
         time:1581148620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.845857,
      },
      {
         time:1581149220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.247081,
      },
      {
         time:1581149820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.103832,
      },
      {
         time:1581150420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.636951,
      },
      {
         time:1581151020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.541230,
      },
      {
         time:1581151620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:606.915410,
      },
      {
         time:1581152220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.140221,
      },
      {
         time:1581152820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.417733,
      },
      {
         time:1581153420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.821805,
      },
      {
         time:1581154020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.972596,
      },
      {
         time:1581154620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.090720,
      },
      {
         time:1581155220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.220482,
      },
      {
         time:1581155820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.519558,
      },
      {
         time:1581156420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.170344,
      },
      {
         time:1581157020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.474931,
      },
      {
         time:1581157620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.145374,
      },
      {
         time:1581158220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.024685,
      },
      {
         time:1581158820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.140216,
      },
      {
         time:1581159420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.082746,
      },
      {
         time:1581160020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.934052,
      },
      {
         time:1581160620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.489268,
      },
      {
         time:1581161220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.500673,
      },
      {
         time:1581161820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.009921,
      },
      {
         time:1581162420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.536588,
      },
      {
         time:1581163020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.206825,
      },
      {
         time:1581163620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.139603,
      },
      {
         time:1581164220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.042936,
      },
      {
         time:1581164820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.091415,
      },
      {
         time:1581165420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.575781,
      },
      {
         time:1581166020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.928252,
      },
      {
         time:1581166620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.174818,
      },
      {
         time:1581167220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.277802,
      },
      {
         time:1581167820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.349154,
      },
      {
         time:1581168420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.138937,
      },
      {
         time:1581169020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.000094,
      },
      {
         time:1581169620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.304403,
      },
      {
         time:1581170220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.840799,
      },
      {
         time:1581170820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.055160,
      },
      {
         time:1581171420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.914613,
      },
      {
         time:1581172020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.141314,
      },
      {
         time:1581172620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.477915,
      },
      {
         time:1581173220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.929874,
      },
      {
         time:1581173820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.664010,
      },
      {
         time:1581174420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.646351,
      },
      {
         time:1581175020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.188205,
      },
      {
         time:1581175620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:612.704606,
      },
      {
         time:1581176220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.822263,
      },
      {
         time:1581176820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.658792,
      },
      {
         time:1581177420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.856844,
      },
      {
         time:1581178020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.285387,
      },
      {
         time:1581178620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.476597,
      },
      {
         time:1581179220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.991307,
      },
      {
         time:1581179820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.341069,
      },
      {
         time:1581180420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.686687,
      },
      {
         time:1581181020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.248311,
      },
      {
         time:1581181620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.837920,
      },
      {
         time:1581182220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.305931,
      },
      {
         time:1581182820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.360444,
      },
      {
         time:1581183420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.205488,
      },
      {
         time:1581184020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.241772,
      },
      {
         time:1581184620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.708757,
      },
      {
         time:1581185220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.301202,
      },
      {
         time:1581185820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.908897,
      },
      {
         time:1581186420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.526217,
      },
      {
         time:1581187020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.878484,
      },
      {
         time:1581187620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.392535,
      },
      {
         time:1581188220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.523248,
      },
      {
         time:1581188820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.283126,
      },
      {
         time:1581189420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.804147,
      },
      {
         time:1581190020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.500423,
      },
      {
         time:1581190620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.749888,
      },
      {
         time:1581191220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.025634,
      },
      {
         time:1581191820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.237480,
      },
      {
         time:1581192420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.886909,
      },
      {
         time:1581193020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.886008,
      },
      {
         time:1581193620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.000188,
      },
      {
         time:1581194220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.002812,
      },
      {
         time:1581194820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.379628,
      },
      {
         time:1581195420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.826399,
      },
      {
         time:1581196020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.226539,
      },
      {
         time:1581196620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.586611,
      },
      {
         time:1581197220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.809349,
      },
      {
         time:1581197820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.104538,
      },
      {
         time:1581198420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.042725,
      },
      {
         time:1581199020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.804630,
      },
      {
         time:1581199620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.182070,
      },
      {
         time:1581200220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.802095,
      },
      {
         time:1581200820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.769084,
      },
      {
         time:1581201420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.255423,
      },
      {
         time:1581202020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.939333,
      },
      {
         time:1581202620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.709081,
      },
      {
         time:1581203220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.859568,
      },
      {
         time:1581203820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.983158,
      },
      {
         time:1581204420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.781631,
      },
      {
         time:1581205020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.988957,
      },
      {
         time:1581205620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.543492,
      },
      {
         time:1581206220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.970369,
      },
      {
         time:1581206820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.136314,
      },
      {
         time:1581207420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.096935,
      },
      {
         time:1581208020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.697515,
      },
      {
         time:1581208620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.579994,
      },
      {
         time:1581209220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.431550,
      },
      {
         time:1581209820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.967539,
      },
      {
         time:1581210420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.177459,
      },
      {
         time:1581211020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.963533,
      },
      {
         time:1581211620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.131209,
      },
      {
         time:1581212220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.851424,
      },
      {
         time:1581212820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.495013,
      },
      {
         time:1581213420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.475171,
      },
      {
         time:1581214020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.164904,
      },
      {
         time:1581214620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.146791,
      },
      {
         time:1581215220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.945125,
      },
      {
         time:1581215820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.362840,
      },
      {
         time:1581216420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.844104,
      },
      {
         time:1581217020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.271010,
      },
      {
         time:1581217620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.658647,
      },
      {
         time:1581218220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.994896,
      },
      {
         time:1581218820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.201348,
      },
      {
         time:1581219420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.057634,
      },
      {
         time:1581220020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:612.328312,
      },
      {
         time:1581220620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.893408,
      },
      {
         time:1581221220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.129999,
      },
      {
         time:1581221820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.236211,
      },
      {
         time:1581222420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.507201,
      },
      {
         time:1581223020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.060015,
      },
      {
         time:1581223620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.631969,
      },
      {
         time:1581224220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.795178,
      },
      {
         time:1581224820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.066295,
      },
      {
         time:1581225420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.608449,
      },
      {
         time:1581226020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.562581,
      },
      {
         time:1581226620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.864939,
      },
      {
         time:1581227220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.878088,
      },
      {
         time:1581227820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.234158,
      },
      {
         time:1581228420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.661764,
      },
      {
         time:1581229020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.180667,
      },
      {
         time:1581229620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.262767,
      },
      {
         time:1581230220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.115226,
      },
      {
         time:1581230820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.478336,
      },
      {
         time:1581231420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.630418,
      },
      {
         time:1581232020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.128567,
      },
      {
         time:1581232620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.618992,
      },
      {
         time:1581233220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.677531,
      },
      {
         time:1581233820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.790506,
      },
      {
         time:1581234420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.619261,
      },
      {
         time:1581235020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.635898,
      },
      {
         time:1581235620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.053748,
      },
      {
         time:1581236220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.163947,
      },
      {
         time:1581236820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.882292,
      },
      {
         time:1581237420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.967714,
      },
      {
         time:1581238020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.557662,
      },
      {
         time:1581238620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.529111,
      },
      {
         time:1581239220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.201760,
      },
      {
         time:1581239820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.735457,
      },
      {
         time:1581240420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.042017,
      },
      {
         time:1581241020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.071713,
      },
      {
         time:1581241620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.042395,
      },
      {
         time:1581242220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.559020,
      },
      {
         time:1581242820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:612.535768,
      },
      {
         time:1581243420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.819371,
      },
      {
         time:1581244020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.507837,
      },
      {
         time:1581244620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.191629,
      },
      {
         time:1581245220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.255815,
      },
      {
         time:1581245820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:608.988154,
      },
      {
         time:1581246420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.184406,
      },
      {
         time:1581247020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.500760,
      },
      {
         time:1581247620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.198311,
      },
      {
         time:1581248220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.103870,
      },
      {
         time:1581248820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:607.541430,
      },
      {
         time:1581249420.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.433431,
      },
      {
         time:1581250020.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.361118,
      },
      {
         time:1581250620.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:611.011799,
      },
      {
         time:1581251220.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:609.538232,
      },
      {
         time:1581251820.000000,
         furnaceTemp:0.000000,
         quenchingTemp:0.000000,
         quenchingAgit:0.000000,
         temperedTemp:610.484728,
      }
   ],
   
     
     
}